import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Row, Col, Badge, Form, Button, Card, CardBody, InputGroup, Modal, Stack, Table } from "react-bootstrap";
import ButtonMui from "@mui/material/Button";
import { Formik } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { NumericFormat } from "react-number-format";
import { NumberFormatFloat, NumberFormat, getPrefixName, filterTextAndNum, getInfoAdminSystem, convertStringNumber, formatNumber } from "utils/HelperFunction";
import DataTableLayout from "layouts/DatatableLayout";
import DownloadExcel from "utils/DownloadExcel";
import moment from "moment";
import "moment/locale/th";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import PrintIcon from "@mui/icons-material/Print";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import ThaiBahtText from "thai-baht-text";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PaymentsIcon from "@mui/icons-material/Payments";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import { StepperLabelWizard } from "layouts/StepperLabelWizard";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { ModalAllder } from "layouts/ModalAllder";
import { NotifyModal } from "layouts/NotifyModal";
import { getAllMstBusiness } from "../../redux/handlers/master/getAllMstBusiness.handler";
import { createQuotation, clearCreateQuotation } from "../../redux/handlers/quotation/createQuotation.handler";
import { updateQuotation, clearUpdateQuotation } from "../../redux/handlers/quotation/updateQuotation.handler";
import { updateQuotationFile, clearUpdateQuotationFile } from "../../redux/handlers/quotation/updateQuotationFile.handler";
import { getQuotationNewById, clearGetQuotationNewById } from "../../redux/handlers/quotation/getQuotationNewById.handler";
import { getQuotationFileById, clearGetQuotationFileById } from "../../redux/handlers/quotation/getQuotationFileById.handler";
import { getQuotationDetailById, clearGetQuotationDetailById } from "../../redux/handlers/quotation/getQuotationDetailById.handler";
import { updateQuotationStatus, clearUpdateQuotationStatus } from "../../redux/handlers/quotation/updateQuotationStatus.handler";
import { getQuotContractInfoById, clearGetQuotContractInfoById } from "../../redux/handlers/quotation/getQuotContractInfoById.handler";
import { getContractById, clearGetContractById } from "../../redux/handlers/contract/getContractById.handler";
import DownloadFile from "utils/DownloadFile";
import { useReactToPrint } from "react-to-print";
import CursorManager from "layouts/CursorManager";
import { Page, Text, View, Document, StyleSheet, Font, Image, pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { Buffer } from "buffer";
import thsarabun from "fonts/THSarabunNew.ttf";
import thsarabunBold from "fonts/THSarabunNewBold.ttf";
import { stylesPdfData } from "mocks/stylesPdfData";
Font.register({
    family: "THSarabun",
    fonts: [
        {
            src: thsarabun
        },
        {
            src: thsarabunBold,
            fontWeight: "bold"
        }
    ]
});
export function QuotationCreate() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var quoteId = useParams().quoteId;
    var _useState = _sliced_to_array(useState({}), 2), formdata = _useState[0], setFormdata = _useState[1];
    var _useState1 = _sliced_to_array(useState("create"), 2), mode = _useState1[0], setMode = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), statusQuot = _useState2[0], setStatusQuot = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), editDisabled = _useState3[0], setEditDisabled = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), chkDisabled = _useState4[0], setChkDisabled = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), quoteCode = _useState5[0], setQuoteCode = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), qrCompanyName = _useState6[0], setQrCompanyName = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), listData = _useState7[0], setListData = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), fileData = _useState8[0], setFileData = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), listDataDel = _useState9[0], setListDataDel = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), fileDataDel = _useState10[0], setFileDataDel = _useState10[1];
    var _useState11 = _sliced_to_array(useState(null), 2), ctDataId = _useState11[0], setCtDataId = _useState11[1];
    var _useState12 = _sliced_to_array(useState(false), 2), loadEditF = _useState12[0], setLoadEditF = _useState12[1];
    var schema = yup.object().shape({});
    var _useState13 = _sliced_to_array(useState({}), 2), partnerInfoNew = _useState13[0], setPartnerInfoNew = _useState13[1];
    var getQuotationNewByIdReducer = useAppSelector(function(state) {
        return state.getQuotationNewByIdReducer;
    });
    var getContractByIdReducer = useAppSelector(function(state) {
        return state.getContractByIdReducer;
    });
    var getData = function() {
        if (quoteId && quoteId > 0) {
            dispatch(getQuotationNewById({
                quotationid: parseInt(quoteId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setMode("updated");
        }
    };
    useEffect(function() {
        setIsLoading(getQuotationNewByIdReducer.isFetching || getContractByIdReducer.isFetching);
        if (getQuotationNewByIdReducer.data && !getQuotationNewByIdReducer.isError) {
            var datas = getQuotationNewByIdReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            if (dataWithReplacements && dataWithReplacements[0]) {
                setFormdata(dataWithReplacements[0]);
            } else if (dataWithReplacements) {
                setFormdata(dataWithReplacements);
            }
        }
        if (getContractByIdReducer.data && !getContractByIdReducer.isError) {
            var datas2 = getContractByIdReducer.data.data;
            if (!datas2) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements2 = Object.entries(datas2).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            var dataInfoNew = {};
            if (dataWithReplacements2 && dataWithReplacements2[0]) {
                dataInfoNew = dataWithReplacements2[0];
            } else if (dataWithReplacements2) {
                dataInfoNew = dataWithReplacements2;
            }
            setFormdata(function(formdata) {
                return _object_spread_props(_object_spread({}, formdata), {
                    qr_quotation_refer: filterTextAndNum(dataInfoNew.ct_contract_code)
                });
            });
        }
    }, [
        getQuotationNewByIdReducer,
        getContractByIdReducer
    ]);
    useEffect(function() {
        getData();
    }, []);
    useEffect(function() {
        if (!formdata) return;
        if (formdata.qr_quotation_status && formdata.qr_quotation_status > 0) {
            setStatusQuot(formdata.qr_quotation_status);
            if (formdata.qr_quotation_status >= 2 && !chkDisabled) {
                setEditDisabled(true);
            }
        }
        if (formdata.qr_quotation_code) {
            setQuoteCode(formdata.qr_quotation_code);
        }
        var contid = formdata === null || formdata === void 0 ? void 0 : formdata.qr_quotation_contid;
        var isValid = contid && contid > 0;
        if (isValid && contid !== ctDataId) {
            setCtDataId(contid);
        //console.log('ctDataId : ',contid);
        }
        var companyName = "";
        if (formdata.qr_quotation_businesstype === 2) {
            companyName = filterTextAndNum(formdata.qr_quotation_comprefixname) + filterTextAndNum(formdata.qr_quotation_name) + filterTextAndNum(formdata.qr_quotation_suffixname);
        } else if (formdata.qr_quotation_businesstype === 1) {
            companyName = getPrefixName(formdata.qr_quotation_prefixid) + filterTextAndNum(formdata.qr_quotation_fname) + " " + filterTextAndNum(formdata.qr_quotation_lname);
        }
        setQrCompanyName(companyName);
    }, [
        formdata
    ]);
    useEffect(function() {
        if (ctDataId && ctDataId > 0) {
            //console.log('ctDataId updated:', ctDataId);
            // ทำงานอื่น ๆ
            dispatch(getContractById({
                contractid: parseInt(ctDataId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        ctDataId
    ]);
    useEffect(function() {
        //console.log('chkDisabled : ', chkDisabled);
        //console.log('editDisabled : ', editDisabled);
        if (loadEditF && chkDisabled) {
            setLoadEditF(false);
            setEditDisabled(false);
        }
    }, [
        chkDisabled,
        editDisabled
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0 mb-1",
                    children: [
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: [
                                "รายรับ",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item ",
                            children: [
                                " ",
                                /*#__PURE__*/ _jsx("a", {
                                    href: "/quotation",
                                    className: "tc-7  text-decoration-none",
                                    children: "ใบเสนอราคา"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: [
                                " ",
                                mode && mode == "updated" ? "ใบเสนอราคาเลขที่ " + quoteCode : "สร้างใบเสนอราคา"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-2",
                children: /*#__PURE__*/ _jsx("h3", {
                    className: "h3",
                    children: mode && mode == "updated" ? "ใบเสนอราคาเลขที่ " + quoteCode : "สร้างใบเสนอราคา"
                })
            }),
            /*#__PURE__*/ _jsx(StepFlowStatus, {
                statusQuot: statusQuot,
                setStatusQuot: setStatusQuot
            }),
            /*#__PURE__*/ _jsx(DetailPartner, {
                mode: mode,
                partnerData: formdata,
                setPartnerData: setFormdata,
                editDisabled: editDisabled,
                setEditDisabled: setEditDisabled,
                statusQuot: statusQuot,
                qrCompanyName: qrCompanyName,
                schema: schema,
                partnerInfoNew: partnerInfoNew,
                setPartnerInfoNew: setPartnerInfoNew
            }),
            /*#__PURE__*/ _jsx(ListData, {
                mode: mode,
                partnerData: formdata,
                setPartnerData: setFormdata,
                listData: listData,
                setListData: setListData,
                editDisabled: editDisabled,
                setEditDisabled: setEditDisabled,
                statusQuot: statusQuot
            }),
            /*#__PURE__*/ _jsx(SummaryResult, {
                mode: mode,
                partnerData: formdata,
                setPartnerData: setFormdata,
                listData: listData,
                setListData: setListData,
                fileData: fileData,
                setFileData: setFileData,
                editDisabled: editDisabled,
                setEditDisabled: setEditDisabled,
                statusQuot: statusQuot,
                schema: schema
            }),
            /*#__PURE__*/ _jsx(BoxSubmitFrom, {
                mode: mode,
                partnerData: formdata,
                setPartnerData: setFormdata,
                listData: listData,
                fileData: fileData,
                listDataDel: listDataDel,
                fileDataDel: fileDataDel,
                editDisabled: editDisabled,
                setEditDisabled: setEditDisabled,
                statusQuot: statusQuot,
                schema: schema,
                quoteCode: quoteCode,
                chkDisabled: chkDisabled,
                setChkDisabled: setChkDisabled,
                partnerInfoNew: partnerInfoNew,
                setLoadEditF: setLoadEditF
            })
        ]
    });
}
export function QuotationByContract() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var contractId = useParams().contractId;
    var _useState = _sliced_to_array(useState({}), 2), formdata = _useState[0], setFormdata = _useState[1];
    var _useState1 = _sliced_to_array(useState("create"), 2), mode = _useState1[0], setMode = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), statusQuot = _useState2[0], setStatusQuot = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), editDisabled = _useState3[0], setEditDisabled = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), chkDisabled = _useState4[0], setChkDisabled = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), quoteCode = _useState5[0], setQuoteCode = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), qrCompanyName = _useState6[0], setQrCompanyName = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), listData = _useState7[0], setListData = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), fileData = _useState8[0], setFileData = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), listDataDel = _useState9[0], setListDataDel = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), fileDataDel = _useState10[0], setFileDataDel = _useState10[1];
    var _useState11 = _sliced_to_array(useState(false), 2), reloadCal = _useState11[0], setReloadCal = _useState11[1];
    var schema = yup.object().shape({});
    var _useState12 = _sliced_to_array(useState({}), 2), partnerInfoNew = _useState12[0], setPartnerInfoNew = _useState12[1];
    var getQuotContractInfoByIdReducer = useAppSelector(function(state) {
        return state.getQuotContractInfoByIdReducer;
    });
    var getContractByIdReducer = useAppSelector(function(state) {
        return state.getContractByIdReducer;
    });
    var getData = function() {
        if (contractId && contractId > 0) {
            dispatch(getQuotContractInfoById({
                contractid: parseInt(contractId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getContractById({
                contractid: parseInt(contractId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    useEffect(function() {
        if (formdata) {
            if (formdata.qr_quotation_businesstype === 2) {
                setQrCompanyName(filterTextAndNum(formdata.qr_quotation_comprefixname) + filterTextAndNum(formdata.qr_quotation_name) + filterTextAndNum(formdata.qr_quotation_suffixname));
            } else {
                setQrCompanyName(formdata.qr_quotation_businesstype === 1 ? getPrefixName(formdata.qr_quotation_prefixid) + filterTextAndNum(formdata.qr_quotation_fname) + " " + filterTextAndNum(formdata.qr_quotation_lname) : "");
            }
        }
    }, [
        formdata
    ]);
    useEffect(function() {
        setIsLoading(getQuotContractInfoByIdReducer.isFetching || getContractByIdReducer.isFetching);
        if (getQuotContractInfoByIdReducer.data && !getQuotContractInfoByIdReducer.isError) {
            var datas = getQuotContractInfoByIdReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            var listDataNewItem = [];
            if (dataWithReplacements && dataWithReplacements[0]) {
                listDataNewItem = dataWithReplacements[0].list;
            } else if (dataWithReplacements) {
                listDataNewItem = dataWithReplacements.list;
            }
            if (listDataNewItem && listDataNewItem.length > 0) {
                setListData(listDataNewItem.map(function(item) {
                    return {
                        rowID: nanoid(),
                        qr_detail_name: filterTextAndNum(item.contractlist),
                        qr_detail_unit: "หน่วย",
                        qr_detail_amount: item.contractamount && item.contractamount > 0 ? parseInt(item.contractamount, 10) : 0,
                        qr_detail_price: filterTextAndNum(item.contractprice, 2),
                        qr_detail_discount: filterTextAndNum(item.contractdiscount, 2),
                        qr_detail_discounttype: 1,
                        qr_detail_pricediscount: filterTextAndNum(item.contractdiscount, 2),
                        qr_detail_net: filterTextAndNum(item.contractprice * item.contractamount - item.contractdiscount, 2),
                        qr_detail_remark: filterTextAndNum(item.contractremark)
                    };
                }));
            }
        }
        if (getContractByIdReducer.data && !getContractByIdReducer.isError) {
            var datas2 = getContractByIdReducer.data.data;
            if (!datas2) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements2 = Object.entries(datas2).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            var dataInfoNew = {};
            if (dataWithReplacements2 && dataWithReplacements2[0]) {
                dataInfoNew = dataWithReplacements2[0];
            } else if (dataWithReplacements2) {
                dataInfoNew = dataWithReplacements2;
            }
            setFormdata(function(formdata) {
                return _object_spread_props(_object_spread({}, formdata), {
                    qr_quotation_memid: filterTextAndNum(dataInfoNew.ct_contract_memid, 1),
                    qr_quotation_contid: filterTextAndNum(dataInfoNew.ct_contract_id, 1),
                    qr_quotation_businessid: filterTextAndNum(dataInfoNew.ct_contract_businessid, 1),
                    qr_quotation_refer: filterTextAndNum(dataInfoNew.ct_contract_code),
                    qr_quotation_businesstype: filterTextAndNum(dataInfoNew.ct_contract_businesstype, 1),
                    qr_quotation_taxid: filterTextAndNum(dataInfoNew.ct_contract_taxid),
                    qr_quotation_categoryid: filterTextAndNum(dataInfoNew.ct_contract_categoryid, 1),
                    qr_quotation_comprefixname: filterTextAndNum(dataInfoNew.ct_contract_comprefixname),
                    qr_quotation_name: filterTextAndNum(dataInfoNew.ct_contract_name),
                    qr_quotation_suffixname: filterTextAndNum(dataInfoNew.ct_contract_suffixname),
                    qr_quotation_vatcode: filterTextAndNum(dataInfoNew.ct_contract_vatcode),
                    qr_quotation_branchname: filterTextAndNum(dataInfoNew.ct_contract_branchname),
                    qr_quotation_prefixid: filterTextAndNum(dataInfoNew.ct_contract_prefixid, 1),
                    qr_quotation_fname: filterTextAndNum(dataInfoNew.ct_contract_fname),
                    qr_quotation_lname: filterTextAndNum(dataInfoNew.ct_contract_lname),
                    qr_quotation_address: filterTextAndNum(dataInfoNew.ct_contract_address),
                    qr_quotation_provinceid: filterTextAndNum(dataInfoNew.ct_contract_provinceid, 1),
                    qr_quotation_subprovinceid: filterTextAndNum(dataInfoNew.ct_contract_subprovinceid, 1),
                    qr_quotation_districtid: filterTextAndNum(dataInfoNew.ct_contract_districtid, 1),
                    qr_quotation_zipcodeid: filterTextAndNum(dataInfoNew.ct_contract_zipcodeid),
                    qr_quotation_mainfname: filterTextAndNum(dataInfoNew.ct_contract_mainfname),
                    qr_quotation_mainlname: filterTextAndNum(dataInfoNew.ct_contract_mainlname),
                    qr_quotation_mainphone: filterTextAndNum(dataInfoNew.ct_contract_mainphone),
                    qr_quotation_mainemail: filterTextAndNum(dataInfoNew.ct_contract_mainemail)
                });
            });
            setReloadCal(true);
        }
    }, [
        getQuotContractInfoByIdReducer,
        getContractByIdReducer
    ]);
    useEffect(function() {
        getData();
    }, []);
    useEffect(function() {
        if (reloadCal && listData && listData.length > 0) {
            var detailNet = 0;
            if (listData && listData.length > 0) {
                listData.map(function(item) {
                    if (item.qr_detail_net && item.qr_detail_net >= 0) {
                        detailNet += filterTextAndNum(item.qr_detail_net, 2);
                    }
                });
            }
            setFormdata(_object_spread_props(_object_spread({}, formdata), {
                qr_quotation_totalprice: filterTextAndNum(detailNet, 2)
            }));
            setReloadCal(false);
        }
    }, [
        listData,
        reloadCal
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0 mb-1",
                    children: [
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: [
                                "รายรับ",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item ",
                            children: [
                                " ",
                                /*#__PURE__*/ _jsx("a", {
                                    href: "/quotation",
                                    className: "tc-7  text-decoration-none",
                                    children: "ใบเสนอราคา"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: [
                                " ",
                                mode && mode == "updated" ? "ใบเสนอราคาเลขที่ " + quoteCode : "สร้างใบเสนอราคา"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-2",
                children: /*#__PURE__*/ _jsx("h3", {
                    className: "h3",
                    children: mode && mode == "updated" ? "ใบเสนอราคาเลขที่ " + quoteCode : "สร้างใบเสนอราคา"
                })
            }),
            /*#__PURE__*/ _jsx(StepFlowStatus, {
                statusQuot: statusQuot,
                setStatusQuot: setStatusQuot
            }),
            /*#__PURE__*/ _jsx(DetailPartner, {
                mode: mode,
                partnerData: formdata,
                setPartnerData: setFormdata,
                editDisabled: editDisabled,
                setEditDisabled: setEditDisabled,
                statusQuot: statusQuot,
                qrCompanyName: qrCompanyName,
                schema: schema,
                partnerInfoNew: partnerInfoNew,
                setPartnerInfoNew: setPartnerInfoNew
            }),
            /*#__PURE__*/ _jsx(ListData, {
                mode: mode,
                partnerData: formdata,
                setPartnerData: setFormdata,
                listData: listData,
                setListData: setListData,
                editDisabled: editDisabled,
                setEditDisabled: setEditDisabled,
                statusQuot: statusQuot
            }),
            /*#__PURE__*/ _jsx(SummaryResult, {
                mode: mode,
                partnerData: formdata,
                setPartnerData: setFormdata,
                listData: listData,
                setListData: setListData,
                fileData: fileData,
                setFileData: setFileData,
                editDisabled: editDisabled,
                setEditDisabled: setEditDisabled,
                statusQuot: statusQuot,
                schema: schema
            }),
            /*#__PURE__*/ _jsx(BoxSubmitFrom, {
                mode: mode,
                partnerData: formdata,
                setPartnerData: setFormdata,
                listData: listData,
                fileData: fileData,
                listDataDel: listDataDel,
                fileDataDel: fileDataDel,
                editDisabled: editDisabled,
                setEditDisabled: setEditDisabled,
                statusQuot: statusQuot,
                schema: schema,
                quoteCode: quoteCode,
                chkDisabled: chkDisabled,
                setChkDisabled: setChkDisabled
            })
        ]
    });
}
function StepFlowStatus(_param) {
    var statusQuot = _param.statusQuot, setStatusQuot = _param.setStatusQuot, props = _object_without_properties(_param, [
        "statusQuot",
        "setStatusQuot"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var steps = [
        "สร้างใบเสนอราคา",
        "ขออนุมัติใบเสนอราคา",
        "อนุมัติแล้ว",
        "หมดอายุ"
    ];
    if (statusQuot == 4) {
        steps = [
            "สร้างใบเสนอราคา",
            "ขออนุมัติใบเสนอราคา",
            "ไม่อนุมัติ",
            "หมดอายุ"
        ];
    }
    var activeBt = statusQuot && statusQuot == 6 ? 4 : statusQuot && statusQuot == 5 ? 0 : statusQuot && statusQuot == 4 ? 3 : statusQuot && statusQuot == 3 ? 3 : statusQuot && statusQuot == 2 ? 2 : 1;
    return /*#__PURE__*/ _jsx("div", {
        className: "mb-4",
        children: /*#__PURE__*/ _jsx(StepperLabelWizard, {
            dataLabel: steps,
            activeStep: activeBt
        })
    });
}
function DetailPartner(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, setPartnerInfoNew = _param.setPartnerInfoNew, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData",
        "setPartnerInfoNew"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var statusQuot = props.statusQuot && props.statusQuot > 0 ? props.statusQuot : 0;
    var mode = props.mode && props.mode != "" && props.mode != null ? props.mode : "create";
    var editDisabled = props.editDisabled ? props.editDisabled : false;
    var schema = props.schema ? props.schema : yup.object().shape({});
    var qrCompanyName = props.qrCompanyName && props.qrCompanyName != "" && props.qrCompanyName != null ? props.qrCompanyName : "";
    var partnerInfoNew = props.partnerInfoNew ? props.partnerInfoNew : {};
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var _useState = _sliced_to_array(useState([]), 2), supplier = _useState[0], setSupplier = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), reLoadData = _useState1[0], setReLoadData = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        companyName: "",
        companyBranch: "",
        companyTaxId: "",
        companyAddress: "",
        companyProvince: "",
        companyDistrict: "",
        companySubDistrict: "",
        companyZipCode: "",
        companyPhone: "",
        companyShortName: ""
    }), 2), partnerInfo = _useState2[0], setPartnerInfo = _useState2[1];
    var optionsMstPayment = [
        {
            value: 1,
            label: "เงินสด"
        },
        {
            value: 2,
            label: "โอนธนาคาร"
        },
        {
            value: 3,
            label: "เช็คเงินสด"
        }
    ];
    var optionsMstPriceType = [
        {
            value: 1,
            label: "รวมภาษี"
        },
        {
            value: 2,
            label: "ไม่รวมภาษี"
        }
    ];
    var optionsMstDiscountType = [
        {
            value: 1,
            label: "บาท"
        },
        {
            value: 2,
            label: "เปอร์เซ็น"
        }
    ];
    var optionsVat = [
        {
            label: "ไม่มี",
            value: 0
        },
        {
            label: "3%",
            value: 3
        },
        {
            label: "7%",
            value: 7
        },
        {
            label: "10%",
            value: 10
        }
    ];
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "fs-12",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.bus_business_company
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#f26f3a"
                    },
                    children: item.bus_business_taxid
                })
            ]
        }, item.bus_business_id);
    };
    var loadAllMsts = function() {
        dispatch(getAllMstBusiness());
    };
    var getAllMstBusinessReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessReducer;
    });
    useEffect(function() {
        setIsLoading(getAllMstBusinessReducer.isFetching);
        if (getAllMstBusinessReducer.data && !getAllMstBusinessReducer.isError) {
            var datas = getAllMstBusinessReducer.data.data.filter(function(item) {
                return item.bus_business_id !== null && item.bus_business_status == 3;
            });
            if (datas && datas.length > 0) {
                setSupplier(datas.map(function(item, index) {
                    return _object_spread_props(_object_spread({}, item), {
                        bus_business_company: item.bus_business_businesstype === 2 ? filterTextAndNum(item.bus_business_comprefixname) + filterTextAndNum(item.bus_business_name) + filterTextAndNum(item.bus_business_suffixname) : item.bus_business_businesstype === 1 ? getPrefixName(item.bus_business_prefixid) + filterTextAndNum(item.bus_business_fname) + " " + filterTextAndNum(item.bus_business_lname) : "ไม่ระบุชื่อธุรกิจ " + (index + 1)
                    });
                }));
                setReLoadData(true);
            }
        }
    }, [
        getAllMstBusinessReducer
    ]);
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        if (reLoadData && partnerData) {
            if (partnerData.qr_quotation_businessid && partnerData.qr_quotation_businessid !== "" && partnerData.qr_quotation_businessid !== null) {
                var slcSupplier = supplier.find(function(item) {
                    return item.bus_business_id === partnerData.qr_quotation_businessid;
                });
                if (slcSupplier) {
                    var _JSON_parse, _slcSupplier_Busprovinceid, _JSON_parse1, _slcSupplier_Bussubprovinceid, _JSON_parse2, _slcSupplier_Busdistrictid;
                    setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                        companyName: slcSupplier.bus_business_company ? slcSupplier.bus_business_company : "-",
                        companyBranch: slcSupplier.bus_business_branchname && slcSupplier.bus_business_branchname != "" && slcSupplier.bus_business_branchname != null ? slcSupplier.bus_business_branchname : "-",
                        companyTaxId: slcSupplier.bus_business_taxid && slcSupplier.bus_business_taxid != "" && slcSupplier.bus_business_taxid != null ? slcSupplier.bus_business_taxid : "-",
                        companyAddress: slcSupplier.bus_business_address && slcSupplier.bus_business_address != "" && slcSupplier.bus_business_address != null ? filterTextAndNum("".concat(slcSupplier.bus_business_address)) : "",
                        companyProvince: slcSupplier.bus_business_provinceid && slcSupplier.bus_business_provinceid != "" && slcSupplier.bus_business_provinceid != null ? JSON.parse(slcSupplier.Busprovinceid.province_name).th : "",
                        companyDistrict: slcSupplier.bus_business_subprovinceid && slcSupplier.bus_business_subprovinceid != "" && slcSupplier.bus_business_subprovinceid != null ? JSON.parse(slcSupplier.Bussubprovinceid.district_name).th : "",
                        companySubDistrict: slcSupplier.bus_business_districtid && slcSupplier.bus_business_districtid != "" && slcSupplier.bus_business_districtid != null ? JSON.parse(slcSupplier.Busdistrictid.subdistrict_name).th : "",
                        companyZipCode: slcSupplier.bus_business_zipcodeid && slcSupplier.bus_business_zipcodeid != "" && slcSupplier.bus_business_zipcodeid != null ? filterTextAndNum("".concat(slcSupplier.bus_business_zipcodeid)) : "",
                        companyPhone: slcSupplier.bus_business_mainphone && slcSupplier.bus_business_mainphone != "" && slcSupplier.bus_business_mainphone != null ? filterTextAndNum("".concat(slcSupplier.bus_business_mainphone)) : "-",
                        companyShortName: slcSupplier.bus_business_shortname && slcSupplier.bus_business_shortname != "" && slcSupplier.bus_business_shortname != null ? filterTextAndNum("".concat(slcSupplier.bus_business_shortname)) : "-"
                    }));
                    setPartnerInfoNew(_object_spread_props(_object_spread({}, partnerInfoNew), {
                        companyName: (slcSupplier === null || slcSupplier === void 0 ? void 0 : slcSupplier.bus_business_company) || "",
                        companyBranch: (slcSupplier === null || slcSupplier === void 0 ? void 0 : slcSupplier.bus_business_branchname) || "",
                        companyTaxId: (slcSupplier === null || slcSupplier === void 0 ? void 0 : slcSupplier.bus_business_taxid) || "",
                        companyAddress: filterTextAndNum((slcSupplier === null || slcSupplier === void 0 ? void 0 : slcSupplier.bus_business_address) || ""),
                        companyProvince: ((_JSON_parse = JSON.parse((slcSupplier === null || slcSupplier === void 0 ? void 0 : (_slcSupplier_Busprovinceid = slcSupplier.Busprovinceid) === null || _slcSupplier_Busprovinceid === void 0 ? void 0 : _slcSupplier_Busprovinceid.province_name) || "{}")) === null || _JSON_parse === void 0 ? void 0 : _JSON_parse.th) || "",
                        companyDistrict: ((_JSON_parse1 = JSON.parse((slcSupplier === null || slcSupplier === void 0 ? void 0 : (_slcSupplier_Bussubprovinceid = slcSupplier.Bussubprovinceid) === null || _slcSupplier_Bussubprovinceid === void 0 ? void 0 : _slcSupplier_Bussubprovinceid.district_name) || "{}")) === null || _JSON_parse1 === void 0 ? void 0 : _JSON_parse1.th) || "",
                        companySubDistrict: ((_JSON_parse2 = JSON.parse((slcSupplier === null || slcSupplier === void 0 ? void 0 : (_slcSupplier_Busdistrictid = slcSupplier.Busdistrictid) === null || _slcSupplier_Busdistrictid === void 0 ? void 0 : _slcSupplier_Busdistrictid.subdistrict_name) || "{}")) === null || _JSON_parse2 === void 0 ? void 0 : _JSON_parse2.th) || "",
                        companyZipCode: filterTextAndNum((slcSupplier === null || slcSupplier === void 0 ? void 0 : slcSupplier.bus_business_zipcodeid) || ""),
                        companyPhone: filterTextAndNum((slcSupplier === null || slcSupplier === void 0 ? void 0 : slcSupplier.bus_business_mainphone) || ""),
                        companyShortName: filterTextAndNum((slcSupplier === null || slcSupplier === void 0 ? void 0 : slcSupplier.bus_business_shortname) || ""),
                        qCode: filterTextAndNum((partnerData === null || partnerData === void 0 ? void 0 : partnerData.qr_quotation_code) || ""),
                        qReferCode: filterTextAndNum((partnerData === null || partnerData === void 0 ? void 0 : partnerData.qr_quotation_refercode) || ""),
                        qReferCtCode: filterTextAndNum((partnerData === null || partnerData === void 0 ? void 0 : partnerData.ct_contract_code) || "")
                    }));
                }
                setReLoadData(false);
            }
        }
    }, [
        partnerData,
        reLoadData
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Formik, {
            enableReinitialize: true,
            initialValues: partnerData,
            validationSchema: schema,
            onSubmit: function() {
                var _ref = _async_to_generator(function(values) {
                    return _ts_generator(this, function(_state) {
                        return [
                            2
                        ];
                    });
                //await sleep(500);
                });
                return function(values) {
                    return _ref.apply(this, arguments);
                };
            }(),
            children: function(param) {
                var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid, resetForm = param.resetForm;
                return /*#__PURE__*/ _jsx(Form, {
                    noValidate: true,
                    onSubmit: handleSubmit,
                    children: /*#__PURE__*/ _jsx("fieldset", {
                        disabled: editDisabled,
                        children: /*#__PURE__*/ _jsx(Card, {
                            className: "card-st-1 mb-4",
                            children: /*#__PURE__*/ _jsxs(CardBody, {
                                children: [
                                    /*#__PURE__*/ _jsxs(Row, {
                                        className: "align-items-center",
                                        xs: 1,
                                        md: 2,
                                        lg: 4,
                                        xl: 5,
                                        children: [
                                            /*#__PURE__*/ _jsx(Col, {
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "เลขที่ใบเสนอราคา"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "qr_quotation_code",
                                                            placeholder: "เลขที่ใบเสนอราคา",
                                                            value: values.qr_quotation_code && values.qr_quotation_code != "" && values.qr_quotation_code != null ? values.qr_quotation_code : "-",
                                                            onChange: function(e) {
                                                                setFieldValue("qr_quotation_code", e.target.value);
                                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                    qr_quotation_code: e.target.value
                                                                }));
                                                            },
                                                            isValid: touched.qr_quotation_code && !errors.qr_quotation_code,
                                                            isInvalid: !!errors.qr_quotation_code,
                                                            disabled: true,
                                                            readOnly: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "วันที่ออกเอกสาร"
                                                        }),
                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                            inputFormat: "DD/MM/YYYY",
                                                            selected: values.qr_quotation_issuedate ? moment(values.qr_quotation_issuedate).toDate() : "",
                                                            onChange: function(date) {
                                                                if (moment(date).isValid()) {
                                                                    // console.log(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    setFieldValue("qr_quotation_issuedate", moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                        qr_quotation_issuedate: moment(date).format("YYYY-MM-DD 00:00:00")
                                                                    }));
                                                                } else {
                                                                    setFieldValue("qr_quotation_issuedate", "");
                                                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                        qr_quotation_issuedate: ""
                                                                    }));
                                                                }
                                                            },
                                                            placeholder: "DD/MM/YYYY",
                                                            className: "w-100 datepicker2 ".concat(values.qr_quotation_issuedate ? "" : !!errors.qr_quotation_issuedate ? "is-invalid" : ""),
                                                            value: values.qr_quotation_issuedate ? moment(values.qr_quotation_issuedate).format("DD/MM/YYYY") : "",
                                                            disabled: editDisabled ? true : false,
                                                            readOnly: editDisabled ? true : false
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "วันที่เอกสารหมดอายุ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                            inputFormat: "DD/MM/YYYY",
                                                            selected: values.qr_quotation_expiredate ? moment(values.qr_quotation_expiredate).toDate() : "",
                                                            onChange: function(date) {
                                                                if (moment(date).isValid()) {
                                                                    // console.log(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    setFieldValue("qr_quotation_issuedate", moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                        qr_quotation_expiredate: moment(date).format("YYYY-MM-DD 00:00:00")
                                                                    }));
                                                                } else {
                                                                    setFieldValue("qr_quotation_expiredate", "");
                                                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                        qr_quotation_expiredate: ""
                                                                    }));
                                                                }
                                                            },
                                                            placeholder: "DD/MM/YYYY",
                                                            className: "w-100 datepicker2 ".concat(values.qr_quotation_expiredate ? "" : !!errors.qr_quotation_expiredate ? "is-invalid" : ""),
                                                            value: values.qr_quotation_expiredate ? moment(values.qr_quotation_expiredate).format("DD/MM/YYYY") : "",
                                                            disabled: editDisabled ? true : false,
                                                            readOnly: editDisabled ? true : false
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "อ้างอิงระบบ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "qr_quotation_refer",
                                                            placeholder: "อ้างอิงระบบ",
                                                            value: values.qr_quotation_refer && values.qr_quotation_refer != "" && values.qr_quotation_refer != null ? values.qr_quotation_refer : "-",
                                                            onChange: function(e) {
                                                                setFieldValue("qr_quotation_refer", e.target.value);
                                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                    qr_quotation_refer: e.target.value
                                                                }));
                                                            },
                                                            isValid: touched.qr_quotation_refer && !errors.qr_quotation_refer,
                                                            isInvalid: !!errors.qr_quotation_refer,
                                                            disabled: true,
                                                            readOnly: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "อ้างอิง"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "qr_quotation_refercode",
                                                            placeholder: "กรุณากรอกเลขอ้างอิงระบบ",
                                                            value: values.qr_quotation_refercode && values.qr_quotation_refercode != "" && values.qr_quotation_refercode != null ? values.qr_quotation_refercode : "",
                                                            onChange: function(e) {
                                                                setFieldValue("qr_quotation_refercode", e.target.value);
                                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                    qr_quotation_refercode: e.target.value
                                                                }));
                                                            },
                                                            isValid: touched.qr_quotation_refercode && !errors.qr_quotation_refercode,
                                                            isInvalid: !!errors.qr_quotation_refercode,
                                                            disabled: editDisabled ? true : false,
                                                            readOnly: editDisabled ? true : false
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Row, {
                                        className: "align-items-center",
                                        xs: 1,
                                        md: 2,
                                        lg: 4,
                                        xl: 5,
                                        children: [
                                            /*#__PURE__*/ _jsx(Col, {
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            style: {
                                                                zIndex: 11
                                                            },
                                                            children: "ลูกค้า"
                                                        }),
                                                        editDisabled ? /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "qr_quotation_company",
                                                            placeholder: "ลูกค้า",
                                                            value: values.qr_quotation_company && values.qr_quotation_company != "" && values.qr_quotation_company != null ? values.qr_quotation_company : qrCompanyName,
                                                            onChange: function(e) {},
                                                            isValid: touched.qr_quotation_company && !errors.qr_quotation_company,
                                                            isInvalid: !!errors.qr_quotation_company,
                                                            disabled: true,
                                                            readOnly: true
                                                        }) : /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                                                            items: supplier,
                                                            placeholder: "กรุณากรอกชื่อลูกค้า",
                                                            onSelect: function(item) {
                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                    qr_quotation_memid: item.bus_business_memid ? item.bus_business_memid : values.qr_quotation_memid,
                                                                    qr_quotation_businessid: item.bus_business_id ? item.bus_business_id : values.qr_quotation_businessid,
                                                                    qr_quotation_businesstype: item.bus_business_businesstype ? item.bus_business_businesstype : values.qr_quotation_businesstype,
                                                                    qr_quotation_taxid: item.bus_business_taxid ? item.bus_business_taxid : values.qr_quotation_taxid,
                                                                    qr_quotation_categoryid: item.bus_business_categoryid ? item.bus_business_categoryid : values.qr_quotation_categoryid,
                                                                    qr_quotation_comprefixid: item.bus_business_comprefixid ? item.bus_business_comprefixid : values.qr_quotation_comprefixid,
                                                                    qr_quotation_comprefixname: item.bus_business_comprefixname ? item.bus_business_comprefixname : values.qr_quotation_comprefixname,
                                                                    qr_quotation_name: item.bus_business_name ? item.bus_business_name : values.qr_quotation_name,
                                                                    qr_quotation_suffixname: item.bus_business_suffixname ? item.bus_business_suffixname : values.qr_quotation_suffixname,
                                                                    qr_quotation_vatcode: item.bus_business_vatcode ? item.bus_business_vatcode : values.qr_quotation_vatcode,
                                                                    qr_quotation_branchname: item.bus_business_branchname ? item.bus_business_branchname : values.qr_quotation_branchname,
                                                                    qr_quotation_prefixid: item.bus_business_prefixid ? item.bus_business_prefixid : values.qr_quotation_prefixid,
                                                                    qr_quotation_fname: item.bus_business_fname ? item.bus_business_fname : values.qr_quotation_fname,
                                                                    qr_quotation_lname: item.bus_business_lname ? item.bus_business_lname : values.qr_quotation_lname,
                                                                    qr_quotation_address: item.bus_business_address ? item.bus_business_address : values.qr_quotation_address,
                                                                    qr_quotation_provinceid: item.bus_business_provinceid ? item.bus_business_provinceid : values.qr_quotation_provinceid,
                                                                    qr_quotation_subprovinceid: item.bus_business_subprovinceid ? item.bus_business_subprovinceid : values.qr_quotation_subprovinceid,
                                                                    qr_quotation_districtid: item.bus_business_districtid ? item.bus_business_districtid : values.qr_quotation_districtid,
                                                                    qr_quotation_zipcodeid: item.bus_business_zipcodeid ? item.bus_business_zipcodeid : values.qr_quotation_zipcodeid,
                                                                    qr_quotation_mainfname: item.bus_business_mainfname ? item.bus_business_mainfname : values.qr_quotation_mainfname,
                                                                    qr_quotation_mainlname: item.bus_business_mainlname ? item.bus_business_mainlname : values.qr_quotation_mainlname,
                                                                    qr_quotation_mainphone: item.bus_business_mainphone ? item.bus_business_mainphone : values.qr_quotation_mainphone,
                                                                    qr_quotation_mainemail: item.bus_business_mainemail ? item.bus_business_mainemail : values.qr_quotation_mainemail
                                                                }));
                                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                    qr_quotation_memid: item.bus_business_memid ? item.bus_business_memid : values.qr_quotation_memid,
                                                                    qr_quotation_businessid: item.bus_business_id ? item.bus_business_id : values.qr_quotation_businessid,
                                                                    qr_quotation_businesstype: item.bus_business_businesstype ? item.bus_business_businesstype : values.qr_quotation_businesstype,
                                                                    qr_quotation_taxid: item.bus_business_taxid ? item.bus_business_taxid : values.qr_quotation_taxid,
                                                                    qr_quotation_categoryid: item.bus_business_categoryid ? item.bus_business_categoryid : values.qr_quotation_categoryid,
                                                                    qr_quotation_comprefixid: item.bus_business_comprefixid ? item.bus_business_comprefixid : values.qr_quotation_comprefixid,
                                                                    qr_quotation_comprefixname: item.bus_business_comprefixname ? item.bus_business_comprefixname : values.qr_quotation_comprefixname,
                                                                    qr_quotation_name: item.bus_business_name ? item.bus_business_name : values.qr_quotation_name,
                                                                    qr_quotation_suffixname: item.bus_business_suffixname ? item.bus_business_suffixname : values.qr_quotation_suffixname,
                                                                    qr_quotation_vatcode: item.bus_business_vatcode ? item.bus_business_vatcode : values.qr_quotation_vatcode,
                                                                    qr_quotation_branchname: item.bus_business_branchname ? item.bus_business_branchname : values.qr_quotation_branchname,
                                                                    qr_quotation_prefixid: item.bus_business_prefixid ? item.bus_business_prefixid : values.qr_quotation_prefixid,
                                                                    qr_quotation_fname: item.bus_business_fname ? item.bus_business_fname : values.qr_quotation_fname,
                                                                    qr_quotation_lname: item.bus_business_lname ? item.bus_business_lname : values.qr_quotation_lname,
                                                                    qr_quotation_address: item.bus_business_address ? item.bus_business_address : values.qr_quotation_address,
                                                                    qr_quotation_provinceid: item.bus_business_provinceid ? item.bus_business_provinceid : values.qr_quotation_provinceid,
                                                                    qr_quotation_subprovinceid: item.bus_business_subprovinceid ? item.bus_business_subprovinceid : values.qr_quotation_subprovinceid,
                                                                    qr_quotation_districtid: item.bus_business_districtid ? item.bus_business_districtid : values.qr_quotation_districtid,
                                                                    qr_quotation_zipcodeid: item.bus_business_zipcodeid ? item.bus_business_zipcodeid : values.qr_quotation_zipcodeid,
                                                                    qr_quotation_mainfname: item.bus_business_mainfname ? item.bus_business_mainfname : values.qr_quotation_mainfname,
                                                                    qr_quotation_mainlname: item.bus_business_mainlname ? item.bus_business_mainlname : values.qr_quotation_mainlname,
                                                                    qr_quotation_mainphone: item.bus_business_mainphone ? item.bus_business_mainphone : values.qr_quotation_mainphone,
                                                                    qr_quotation_mainemail: item.bus_business_mainemail ? item.bus_business_mainemail : values.qr_quotation_mainemail,
                                                                    qr_quotation_company: item.qr_quotation_company ? item.qr_quotation_company : values.qr_quotation_company
                                                                }));
                                                                setPartnerInfo({
                                                                    companyName: item.bus_business_company ? item.bus_business_company : "-",
                                                                    companyBranch: item.bus_business_branchname && item.bus_business_branchname != "" && item.bus_business_branchname != null ? item.bus_business_branchname : "-",
                                                                    companyTaxId: item.bus_business_taxid && item.bus_business_taxid != "" && item.bus_business_taxid != null ? item.bus_business_taxid : "-",
                                                                    companyAddress: item.bus_business_address && item.bus_business_address != "" && item.bus_business_address != null ? filterTextAndNum("".concat(item.bus_business_address)) : "",
                                                                    companyProvince: item.bus_business_provinceid && item.bus_business_provinceid != "" && item.bus_business_provinceid != null ? JSON.parse(item.Busprovinceid.province_name).th : "",
                                                                    companyDistrict: item.bus_business_subprovinceid && item.bus_business_subprovinceid != "" && item.bus_business_subprovinceid != null ? JSON.parse(item.Bussubprovinceid.district_name).th : "",
                                                                    companySubDistrict: item.bus_business_districtid && item.bus_business_districtid != "" && item.bus_business_districtid != null ? JSON.parse(item.Busdistrictid.subdistrict_name).th : "",
                                                                    companyZipCode: item.bus_business_zipcodeid && item.bus_business_zipcodeid != "" && item.bus_business_zipcodeid != null ? filterTextAndNum("".concat(item.bus_business_zipcodeid)) : "",
                                                                    companyPhone: item.bus_business_mainphone && item.bus_business_mainphone != "" && item.bus_business_mainphone != null ? filterTextAndNum("".concat(item.bus_business_mainphone)) : "-",
                                                                    companyShortName: item.bus_business_shortname && item.bus_business_shortname != "" && item.bus_business_shortname != null ? filterTextAndNum("".concat(item.bus_business_shortname)) : "-"
                                                                });
                                                            },
                                                            onClear: function() {
                                                                setFieldValue("customer_id", "");
                                                                setPartnerInfo({
                                                                    companyName: "",
                                                                    companyBranch: "",
                                                                    companyTaxId: "",
                                                                    companyAddress: "",
                                                                    companyProvince: "",
                                                                    companyDistrict: "",
                                                                    companySubDistrict: "",
                                                                    companyZipCode: "",
                                                                    companyPhone: "",
                                                                    companyShortName: ""
                                                                });
                                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                    qr_quotation_memid: "",
                                                                    qr_quotation_businessid: "",
                                                                    qr_quotation_businesstype: "",
                                                                    qr_quotation_taxid: "",
                                                                    qr_quotation_categoryid: "",
                                                                    qr_quotation_comprefixid: "",
                                                                    qr_quotation_comprefixname: "",
                                                                    qr_quotation_name: "",
                                                                    qr_quotation_suffixname: "",
                                                                    qr_quotation_vatcode: "",
                                                                    qr_quotation_branchname: "",
                                                                    qr_quotation_prefixid: "",
                                                                    qr_quotation_fname: "",
                                                                    qr_quotation_lname: "",
                                                                    qr_quotation_address: "",
                                                                    qr_quotation_provinceid: "",
                                                                    qr_quotation_subprovinceid: "",
                                                                    qr_quotation_districtid: "",
                                                                    qr_quotation_zipcodeid: "",
                                                                    qr_quotation_mainfname: "",
                                                                    qr_quotation_mainlname: "",
                                                                    qr_quotation_mainphone: "",
                                                                    qr_quotation_mainemail: ""
                                                                }));
                                                            },
                                                            autoFocus: true,
                                                            formatResult: formatResult,
                                                            fuseOptions: {
                                                                keys: [
                                                                    "bus_business_company",
                                                                    "bus_business_taxid",
                                                                    "bus_business_id"
                                                                ]
                                                            },
                                                            resultStringKeyName: "bus_business_company",
                                                            styling: {
                                                                height: "50px",
                                                                borderRadius: "10px",
                                                                boxShadow: "none",
                                                                zIndex: 10,
                                                                border: !values.customer_id ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                                                            },
                                                            showIcon: false,
                                                            className: "scrollSearchAutocomplete"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "ประเภทราคา"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Select, {
                                                            as: "select",
                                                            name: "qr_quotation_vattype",
                                                            onChange: function(e) {
                                                                setFieldValue("qr_quotation_vattype", e.value);
                                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                    qr_quotation_vattype: e.value
                                                                }));
                                                            },
                                                            className: "w-100 select-st-1",
                                                            options: optionsMstPriceType,
                                                            placeholder: "เลือกประเภทราคา",
                                                            value: optionsMstPriceType.filter(function(item) {
                                                                return item.value === values.qr_quotation_vattype;
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "ประเภทการชำระเงิน"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Select, {
                                                            as: "select",
                                                            name: "qr_quotation_paytype",
                                                            onChange: function(e) {
                                                                setFieldValue("qr_quotation_paytype", e.value);
                                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                                    qr_quotation_paytype: e.value
                                                                }));
                                                            },
                                                            className: "w-100 select-st-1",
                                                            options: optionsMstPayment,
                                                            placeholder: "เลือกประเภทการชำระเงิน",
                                                            value: optionsMstPayment.filter(function(item) {
                                                                return item.value === values.qr_quotation_paytype;
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                    className: "mb-2 form-st-3 pb-1",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                            className: "mb-1",
                                                            children: "ผู้จัดทำเอกสาร"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: "text",
                                                            name: "doc_create",
                                                            className: "form-control",
                                                            placeholder: "",
                                                            value: values.qr_quotation_crebyid && values.qr_quotation_crebyid != "" && values.qr_quotation_crebyid != null ? values.sys_user_fullname : adminInfo && adminInfo.userId && adminInfo.userId != "" && adminInfo.userId != null ? adminInfo.userFullName : "-",
                                                            onChange: handleChange,
                                                            disabled: true
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Row, {
                                        xs: 1,
                                        md: 2,
                                        lg: 4,
                                        xl: 5,
                                        children: [
                                            /*#__PURE__*/ _jsxs(Col, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold mb-3 tc-1",
                                                        children: "ชื่อลูกค้า"
                                                    }),
                                                    partnerInfo.companyName && partnerInfo.companyName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("p", {
                                                                className: "fs-18 mb-2",
                                                                children: partnerInfo.companyName
                                                            }),
                                                            /*#__PURE__*/ _jsxs("p", {
                                                                className: "fs-18 mb-2",
                                                                children: [
                                                                    "สาขา : ",
                                                                    partnerInfo.companyBranch
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 mb-2",
                                                        children: "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold mb-3 tc-1",
                                                        children: "ที่อยู่"
                                                    }),
                                                    partnerInfo.companyAddress && partnerInfo.companyAddress != "" ? /*#__PURE__*/ _jsx(_Fragment, {
                                                        children: /*#__PURE__*/ _jsx("p", {
                                                            className: "fs-18 mb-2",
                                                            children: partnerInfo.companyAddress + ", " + partnerInfo.companySubDistrict + ", " + partnerInfo.companyDistrict + ", " + partnerInfo.companyProvince + ", " + partnerInfo.companyZipCode
                                                        })
                                                    }) : /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 mb-2",
                                                        children: "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold mb-3 tc-1",
                                                        children: "เบอร์โทร"
                                                    }),
                                                    partnerInfo.companyPhone && partnerInfo.companyPhone != "" ? /*#__PURE__*/ _jsx(_Fragment, {
                                                        children: /*#__PURE__*/ _jsx("p", {
                                                            className: "fs-18 mb-2",
                                                            children: partnerInfo.companyPhone
                                                        })
                                                    }) : /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 mb-2",
                                                        children: "-"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Col, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 fw-bold mb-3 tc-1",
                                                        children: "ชื่อย่อ"
                                                    }),
                                                    partnerInfo.companyShortName && partnerInfo.companyShortName != "" ? /*#__PURE__*/ _jsx(_Fragment, {
                                                        children: /*#__PURE__*/ _jsx("p", {
                                                            className: "fs-18 mb-2",
                                                            children: partnerInfo.companyShortName
                                                        })
                                                    }) : /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-18 mb-2",
                                                        children: "-"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                });
            }
        })
    });
}
function ListData(_param) {
    var listData = _param.listData, setListData = _param.setListData, props = _object_without_properties(_param, [
        "listData",
        "setListData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var quoteId = useParams().quoteId;
    var statusQuot = props.statusQuot && props.statusQuot > 0 ? props.statusQuot : 0;
    var mode = props.mode && props.mode != "" && props.mode != null ? props.mode : "create";
    var editDisabled = props.editDisabled ? props.editDisabled : false;
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var _useState = _sliced_to_array(useState(false), 2), reloadCal = _useState[0], setReloadCal = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), listDelOld = _useState1[0], setListDelOld = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        sumAmount: 0,
        sumPrice: 0,
        sumPreDis: 0,
        sumDisC: 0,
        sumPreTax: 0,
        sumNet: 0
    }), 2), listSum = _useState2[0], setListSum = _useState2[1];
    var getQuotationDetailByIdReducer = useAppSelector(function(state) {
        return state.getQuotationDetailByIdReducer;
    });
    var getData = function() {
        if (quoteId && quoteId > 0) {
            dispatch(getQuotationDetailById({
                quotationid: parseInt(quoteId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    var handleDeleteRow = function(rowId, idFile) {
        if (rowId && rowId != "" && rowId != null) {
            setListData(function(listData) {
                return listData.filter(function(item) {
                    return item.rowID !== rowId;
                });
            });
            if (idFile && idFile != "" && idFile != null && idFile > 0) {
                setListDelOld(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            qr_detail_id: parseInt(idFile, 10)
                        }
                    ]);
                });
            }
        }
    };
    var handleAddRow = function() {
        var newRow = {
            rowID: nanoid(),
            qr_detail_id: 0,
            qr_detail_name: "",
            qr_detail_unit: "",
            qr_detail_amount: 0,
            qr_detail_price: 0,
            qr_detail_discount: 0,
            qr_detail_discounttype: 1,
            qr_detail_pricediscount: 0,
            qr_detail_net: 0,
            qr_detail_remark: ""
        };
        setListData(function(prev) {
            return _to_consumable_array(prev).concat([
                newRow
            ]);
        });
    };
    var optionsMstDiscount = [
        {
            value: 1,
            label: "บาท"
        },
        {
            value: 2,
            label: "เปอร์เซ็น"
        }
    ];
    useEffect(function() {
        setIsLoading(getQuotationDetailByIdReducer.isFetching);
        if (getQuotationDetailByIdReducer.data && !getQuotationDetailByIdReducer.isError) {
            var datas = getQuotationDetailByIdReducer.data.data;
            if (datas && datas.length > 0) {
                setListData(datas.map(function(item) {
                    return _object_spread_props(_object_spread({}, item), {
                        rowID: nanoid()
                    });
                }));
                setReloadCal(true);
            }
        }
    }, [
        getQuotationDetailByIdReducer
    ]);
    useEffect(function() {
        getData();
    }, []);
    useEffect(function() {
        if (reloadCal && listData && listData.length > 0) {
            setReloadCal(false);
            //console.log("listData : ",listData);
            var sumAmount = 0;
            var sumPrice = 0;
            var sumDiscount = 0;
            var sumPreDis = 0;
            var sumTax = 0;
            var sumPreTax = 0;
            var sumVat = 0;
            var sumNet = 0;
            var sumDiscountReal = 0;
            var listDataNew = [];
            listData.map(function(item, index) {
                var listAmount = 0;
                var pretax = 0;
                var predis = 0;
                var taxVale = 0;
                var vatVale = 0;
                var netVale = 0;
                var discount = 0;
                if (item.qr_detail_amount && item.qr_detail_amount > 0) {
                    listAmount = parseInt(item.qr_detail_amount, 10);
                } else {
                    listAmount = 0;
                }
                if (item.qr_detail_price && item.qr_detail_price > 0 && listAmount > 0) {
                    if (item.qr_detail_discounttype && item.qr_detail_discounttype == 2) {
                        var totalPrice = parseFloat(item.qr_detail_price) * parseFloat(listAmount);
                        discount = totalPrice * parseFloat(item.qr_detail_discount) / 100;
                    } else {
                        discount = item.qr_detail_discount && item.qr_detail_discount > 0 ? parseFloat(item.qr_detail_discount) : 0;
                    }
                    if (item.qr_detail_discount && item.qr_detail_discount > 0) {
                        pretax = parseFloat(item.qr_detail_price) * parseFloat(listAmount) - parseFloat(discount);
                    } else {
                        pretax = parseFloat(item.qr_detail_price) * parseFloat(listAmount);
                    }
                    netVale = parseFloat(pretax);
                    predis = parseFloat(item.qr_detail_price) * parseFloat(listAmount);
                } else {
                    pretax = 0;
                    predis = 0;
                    taxVale = 0;
                    vatVale = 0;
                    netVale = 0;
                }
                listDataNew = _to_consumable_array(listDataNew).concat([
                    _object_spread_props(_object_spread({}, item), {
                        qr_detail_discountreal: parseFloat(discount),
                        qr_detail_pricediscount: parseFloat(pretax),
                        qr_detail_net: parseFloat(netVale),
                        qr_detail_crebyid: item.qr_detail_crebyid && item.qr_detail_crebyid > 0 ? parseFloat(item.qr_detail_crebyid) : parseFloat(adminInfo.userId)
                    })
                ]);
                if (listAmount && listAmount > 0) {
                    sumAmount += parseInt(listAmount, 10);
                }
                if (discount && discount > 0) {
                    sumDiscountReal += parseFloat(discount);
                }
                if (item.qr_detail_price && item.qr_detail_price > 0) {
                    sumPrice += parseFloat(item.qr_detail_price);
                }
                if (item.qr_detail_discount && item.qr_detail_discount > 0) {
                    sumDiscount += parseFloat(item.qr_detail_discount);
                }
                if (pretax && pretax > 0) {
                    sumPreTax += parseFloat(pretax);
                }
                if (netVale && netVale > 0) {
                    sumNet += parseFloat(netVale);
                }
                if (predis && predis > 0) {
                    sumPreDis += parseFloat(predis);
                }
            });
            if (listDataNew && listDataNew.length > 0) {
                setListData(listDataNew);
                setListSum(_object_spread_props(_object_spread({}, listSum), {
                    sumAmount: parseInt(sumAmount, 10),
                    sumPrice: parseFloat(sumPrice),
                    sumPreDis: parseFloat(sumPreDis),
                    sumDisC: parseFloat(sumDiscount),
                    sumPreTax: parseFloat(sumPreTax),
                    sumNet: parseFloat(sumNet)
                }));
                props.setPartnerData(_object_spread_props(_object_spread({}, props.partnerData), {
                    qr_quotation_totalprice: parseFloat(sumNet),
                    qr_quotation_d_sum_amount: parseInt(sumAmount, 10),
                    qr_quotation_d_sum_price: parseFloat(sumPrice),
                    qr_quotation_d_sum_discount: parseFloat(sumDiscountReal),
                    qr_quotation_d_sum_pre_tax: parseFloat(sumPreTax),
                    qr_quotation_d_sum_net: parseFloat(sumNet)
                }));
            }
        }
    }, [
        listData,
        reloadCal
    ]);
    useEffect(function() {
        if (listDelOld && listDelOld.length > 0 && quoteId && quoteId != "" && quoteId != null && quoteId > 0) {
            props.setPartnerData(_object_spread_props(_object_spread({}, props.partnerData), {
                qr_detail_delete: listDelOld
            }));
        }
    }, [
        listDelOld
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "my-4",
                children: /*#__PURE__*/ _jsxs(Table, {
                    striped: true,
                    bordered: true,
                    responsive: true,
                    children: [
                        /*#__PURE__*/ _jsx("thead", {
                            children: /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center",
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center",
                                        children: "รายการ"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center",
                                        children: "หน่วย"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center",
                                        children: "จำนวน"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center",
                                        children: "ราคา/หน่วย"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center",
                                        children: "มูลค่าก่อนส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center bg-th-danger",
                                        children: "ส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center",
                                        children: "ประเภทส่วนลด"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center",
                                        children: "มูลค่าสุทธิ"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "text-center",
                                        children: "หมายเหตุ"
                                    }),
                                    !editDisabled && listData && listData.length > 0 ? /*#__PURE__*/ _jsx("th", {
                                        className: "text-center"
                                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("tbody", {
                            children: [
                                listData && listData.length > 0 ? listData.map(function(item, index) {
                                    return /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle text-center",
                                                style: {
                                                    minWidth: 80
                                                },
                                                children: index + 1
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle",
                                                style: {
                                                    minWidth: 200
                                                },
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "qr_detail_name",
                                                    placeholder: "ชื่อรายการ",
                                                    style: {
                                                        minWidth: 200
                                                    },
                                                    onChange: function(e) {
                                                        setListData(function(prev) {
                                                            return prev.map(function(el) {
                                                                if (el.rowID === item.rowID) {
                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                        qr_detail_name: e.target.value
                                                                    });
                                                                }
                                                                return el;
                                                            });
                                                        });
                                                    },
                                                    value: item.qr_detail_name != null && item.qr_detail_name != "" && item.qr_detail_name != "null" ? item.qr_detail_name : "",
                                                    disabled: editDisabled,
                                                    readOnly: editDisabled
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle text-center",
                                                style: {
                                                    minWidth: 100
                                                },
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "qr_detail_unit",
                                                    placeholder: "ชื่อหน่วย",
                                                    style: {
                                                        minWidth: 100
                                                    },
                                                    onChange: function(e) {
                                                        setListData(function(prev) {
                                                            return prev.map(function(el) {
                                                                if (el.rowID === item.rowID) {
                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                        qr_detail_unit: e.target.value
                                                                    });
                                                                }
                                                                return el;
                                                            });
                                                        });
                                                    },
                                                    value: item.qr_detail_unit != null && item.qr_detail_unit != "" && item.qr_detail_unit != "null" ? item.qr_detail_unit : "",
                                                    disabled: editDisabled,
                                                    readOnly: editDisabled
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle text-center",
                                                style: {
                                                    minWidth: 100
                                                },
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "number",
                                                    name: "qr_detail_amount",
                                                    placeholder: "จำนวน",
                                                    style: {
                                                        minWidth: 100
                                                    },
                                                    onChange: function(e) {
                                                        setListData(function(prev) {
                                                            return prev.map(function(el) {
                                                                if (el.rowID === item.rowID) {
                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                        qr_detail_amount: e.target.value
                                                                    });
                                                                }
                                                                return el;
                                                            });
                                                        });
                                                        setReloadCal(true);
                                                    },
                                                    value: item.qr_detail_amount != null && item.qr_detail_amount != "" && item.qr_detail_amount != "null" ? parseInt(item.qr_detail_amount, 10) : "",
                                                    disabled: editDisabled,
                                                    readOnly: editDisabled
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle text-center",
                                                style: {
                                                    minWidth: 150
                                                },
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "number",
                                                    placeholder: "ราคา/หน่วย",
                                                    name: "qr_detail_price",
                                                    style: {
                                                        minWidth: 150
                                                    },
                                                    onChange: function(e) {
                                                        setListData(function(prev) {
                                                            return prev.map(function(el) {
                                                                if (el.rowID === item.rowID) {
                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                        qr_detail_price: e.target.value
                                                                    });
                                                                }
                                                                return el;
                                                            });
                                                        });
                                                        setReloadCal(true);
                                                    },
                                                    value: item.qr_detail_price != null && item.qr_detail_price != "" && item.qr_detail_price != "null" ? NumberFormatFloat(item.qr_detail_price, 2) : "",
                                                    disabled: editDisabled,
                                                    readOnly: editDisabled
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle text-center",
                                                style: {
                                                    minWidth: 150
                                                },
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    value: item.qr_detail_price * item.qr_detail_amount,
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    displayType: "text"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle text-center bg-td-danger",
                                                style: {
                                                    minWidth: 150
                                                },
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "number",
                                                    placeholder: "ส่วนลด",
                                                    name: "qr_detail_discount",
                                                    style: {
                                                        minWidth: 150
                                                    },
                                                    onChange: function(e) {
                                                        setListData(function(prev) {
                                                            return prev.map(function(el) {
                                                                if (el.rowID === item.rowID) {
                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                        qr_detail_discount: e.target.value
                                                                    });
                                                                }
                                                                return el;
                                                            });
                                                        });
                                                        setReloadCal(true);
                                                    },
                                                    value: item.qr_detail_discount != null && item.qr_detail_discount != "" && item.qr_detail_discount != "null" ? NumberFormatFloat(item.qr_detail_discount, 2) : "",
                                                    disabled: editDisabled,
                                                    readOnly: editDisabled
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle text-center",
                                                style: {
                                                    minWidth: 150
                                                },
                                                children: /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({}, rest), {
                                                    as: "select",
                                                    name: "qr_detail_discounttype_" + (index + 1),
                                                    onChange: function(e) {
                                                        setListData(function(prev) {
                                                            return prev.map(function(el) {
                                                                if (el.rowID === item.rowID) {
                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                        qr_detail_discounttype: e.value
                                                                    });
                                                                }
                                                                return el;
                                                            });
                                                        });
                                                        setReloadCal(true);
                                                    },
                                                    className: "select-st-1 w-100",
                                                    options: optionsMstDiscount,
                                                    placeholder: "เลือกประเภทส่วนลด",
                                                    value: optionsMstDiscount.filter(function(item2) {
                                                        return item2.value === item.qr_detail_discounttype;
                                                    }),
                                                    isDisabled: editDisabled
                                                }))
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle text-center",
                                                style: {
                                                    minWidth: 150
                                                },
                                                children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                    value: item.qr_detail_net,
                                                    thousandSeparator: ",",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true,
                                                    displayType: "text"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle",
                                                style: {
                                                    minWidth: 200
                                                },
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    placeholder: "หมายเหตุ",
                                                    style: {
                                                        minWidth: "200px"
                                                    },
                                                    onChange: function(e) {
                                                        setListData(function(prev) {
                                                            return prev.map(function(el) {
                                                                if (el.rowID === item.rowID) {
                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                        qr_detail_remark: e.target.value
                                                                    });
                                                                }
                                                                return el;
                                                            });
                                                        });
                                                    },
                                                    value: item.qr_detail_remark != null && item.qr_detail_remark != "" && item.qr_detail_remark != "null" ? item.qr_detail_remark : ""
                                                })
                                            }),
                                            !editDisabled ? /*#__PURE__*/ _jsx("td", {
                                                className: "align-middle text-center",
                                                style: {
                                                    minWidth: 60
                                                },
                                                children: /*#__PURE__*/ _jsx(IconButton, {
                                                    "aria-label": "delete",
                                                    color: "error",
                                                    onClick: function() {
                                                        return handleDeleteRow(item.rowID, item.qr_detail_id);
                                                    },
                                                    children: /*#__PURE__*/ _jsx(Avatar, {
                                                        sx: {
                                                            color: "rgba(176,4,18,1)",
                                                            bgcolor: "rgba(246,225,227,1)"
                                                        },
                                                        children: /*#__PURE__*/ _jsx(DeleteIcon, {
                                                            fontSize: "inherit"
                                                        })
                                                    })
                                                })
                                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                        ]
                                    });
                                }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                                /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 80
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 200
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 100
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 100
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 150
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 150
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 150
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 150
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 150
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 200
                                            }
                                        }),
                                        !editDisabled && listData && listData.length > 0 ? /*#__PURE__*/ _jsx("td", {
                                            style: {
                                                minWidth: 60
                                            }
                                        }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            colSpan: 3,
                                            className: "text-end fw-bold",
                                            children: "รวม"
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "text-center fw-bold",
                                            children: parseInt(listSum.sumAmount, 10)
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "text-end fw-bold",
                                            children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                value: listSum.sumPrice,
                                                thousandSeparator: ",",
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                displayType: "text"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "text-end fw-bold",
                                            children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                value: listSum.sumPreDis,
                                                thousandSeparator: ",",
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                displayType: "text"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "text-end bg-td-danger fw-bold"
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "text-end fw-bold"
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "text-end fw-bold",
                                            children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                value: listSum.sumNet,
                                                thousandSeparator: ",",
                                                decimalScale: 2,
                                                fixedDecimalScale: true,
                                                displayType: "text"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: ""
                                        }),
                                        !editDisabled && listData && listData.length > 0 ? /*#__PURE__*/ _jsx("td", {}) : /*#__PURE__*/ _jsx(_Fragment, {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "my-4",
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    className: "btn-st-3 me-3",
                    variant: "",
                    onClick: handleAddRow,
                    disabled: editDisabled ? true : false,
                    children: "เพิ่มแถว"
                })
            })
        ]
    });
}
function SummaryResult(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var _useParams = useParams(), quoteId = _useParams.quoteId, contractId = _useParams.contractId;
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var statusQuot = props.statusQuot && props.statusQuot > 0 ? props.statusQuot : 0;
    var mode = props.mode && props.mode != "" && props.mode != null ? props.mode : "create";
    var editDisabled = props.editDisabled ? props.editDisabled : false;
    var schema = props.schema ? props.schema : yup.object().shape({});
    var _useState = _sliced_to_array(useState(""), 2), quoteCode = _useState[0], setQuoteCode = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumTotal = _useState1[0], setSumTotal = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumPreDisC = _useState2[0], setSumPreDisC = _useState2[1];
    var _useState3 = _sliced_to_array(useState(1), 2), typeDisC = _useState3[0], setTypeDisC = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), amountDisC = _useState4[0], setAmountDisC = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), totalDisC = _useState5[0], setTotalDisC = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), preTax = _useState6[0], setPreTax = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), typeVat = _useState7[0], setTypeVat = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), totalVat = _useState8[0], setTotalVat = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), typeTax = _useState9[0], setTypeTax = _useState9[1];
    var _useState10 = _sliced_to_array(useState(0), 2), totalTax = _useState10[0], setTotalTax = _useState10[1];
    var _useState11 = _sliced_to_array(useState(true), 2), collapse = _useState11[0], setCollapse = _useState11[1];
    var _useState12 = _sliced_to_array(useState(""), 2), remark = _useState12[0], setRemark = _useState12[1];
    var _useState13 = _sliced_to_array(useState(""), 2), textImg = _useState13[0], setTextImg = _useState13[1];
    var _useState14 = _sliced_to_array(useState(false), 2), isUpfile = _useState14[0], setIsUpfile = _useState14[1];
    var _useState15 = _sliced_to_array(useState([]), 2), fileDelOld = _useState15[0], setFileDelOld = _useState15[1];
    var _useState16 = _sliced_to_array(useState([]), 2), fileUpLoad = _useState16[0], setFileUpLoad = _useState16[1];
    var updateQuotationFileReducer = useAppSelector(function(state) {
        return state.updateQuotationFileReducer;
    });
    var getQuotationFileByIdReducer = useAppSelector(function(state) {
        return state.getQuotationFileByIdReducer;
    });
    var getData = function() {
        if (quoteId && quoteId > 0) {
            dispatch(getQuotationFileById({
                quotationid: parseInt(quoteId, 10)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    var _useState17 = _sliced_to_array(useState([
        {
            value: 0,
            label: "ไม่ระบุ"
        },
        {
            value: 1,
            label: "1%"
        },
        {
            value: 2,
            label: "2%"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 5,
            label: "5%"
        }
    ]), 2), optionsMstTax = _useState17[0], setOptionsMstTax = _useState17[1];
    var optionsMstVat = [
        {
            value: 0,
            label: "ไม่มี"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 7,
            label: "7%"
        },
        {
            value: 10,
            label: "10%"
        }
    ];
    var optionsMstDiscountType = [
        {
            value: 1,
            label: "บาท"
        },
        {
            value: 2,
            label: "เปอร์เซ็น"
        }
    ];
    var boxShowResult = function() {
        var totalValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        if (totalValue && totalValue >= 0.00) {
            totalValue = parseFloat(totalValue).toFixed(2);
        } else {
            totalValue = parseFloat(0).toFixed(2);
        }
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsxs(Row, {
                className: "align-items-center",
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        xs: "auto",
                        md: 12,
                        className: "text-end mb-2",
                        children: "มูลค่าสุทธิรวม"
                    }),
                    /*#__PURE__*/ _jsx(Col, {
                        md: "auto",
                        className: "mb-2 ms-auto",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "text-white text-end fs-24",
                            style: {
                                background: "#B00412",
                                padding: "12px 20px",
                                borderRadius: "8px",
                                minWidth: 200
                            },
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                        value: totalValue,
                                        thousandSeparator: ",",
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        displayType: "text"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "fs-14 ms-2",
                                    children: "บาท"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    var boxSumResult = function() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    className: "align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            className: "text-end pr-1 mb-2",
                            children: "มูลค่าสินค้าก่อนส่วนลด"
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 4,
                            className: "px-1 mb-2",
                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                name: "qr_quotation_totalprice",
                                className: "text-end",
                                placeholder: "มูลค่าสินค้าก่อนส่วนลด",
                                "aria-label": "Disabled Total Tax",
                                value: NumberFormat(sumPreDisC, 2),
                                disabled: true,
                                readOnly: true
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: "auto",
                            className: "pl-1 mb-2",
                            children: "บาท"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    className: "align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            className: "text-end pr-1 mb-2",
                            children: "ส่วนลด"
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 4,
                            className: "px-1 mb-2",
                            children: /*#__PURE__*/ _jsxs(InputGroup, {
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "number",
                                        name: "qr_quotation_discount",
                                        placeholder: "",
                                        value: amountDisC,
                                        onChange: function(e) {
                                            setAmountDisC(e.target.value);
                                            setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                qr_quotation_discount: e.target.value
                                            }));
                                        },
                                        disabled: editDisabled ? true : false
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "qr_quotation_discounttype",
                                        onChange: function(e) {
                                            setTypeDisC(e.value);
                                            setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                qr_quotation_discounttype: e.value
                                            }));
                                        },
                                        className: "select-st-2",
                                        options: optionsMstDiscountType,
                                        placeholder: "",
                                        value: optionsMstDiscountType.filter(function(item) {
                                            return item.value === typeDisC;
                                        }),
                                        isDisabled: editDisabled ? true : false
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 4,
                            className: "px-1 mb-2",
                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                name: "qr_quotation_discountreal",
                                className: "text-end",
                                placeholder: "มูลค่าของส่วนลด",
                                "aria-label": "Disabled Total Discount",
                                value: NumberFormat(totalDisC, 2),
                                readOnly: true
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: "auto",
                            className: "pl-1 mb-2",
                            children: "บาท"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    className: "align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            className: "text-end pr-1 mb-2",
                            children: "มูลค่าสินค้าหลังหักส่วนลด"
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 4,
                            className: "px-1 mb-2",
                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                name: "qr_quotation_pricediscount",
                                className: "text-end",
                                placeholder: "มูลค่าสินค้าหลังหักส่วนลด",
                                "aria-label": "Disabled Total Price Discount",
                                value: NumberFormat(preTax, 2),
                                disabled: true,
                                readOnly: true
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: "auto",
                            className: "pl-1 mb-2",
                            children: "บาท"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    className: "align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            className: "text-end pr-1 mb-2",
                            children: "ภาษีมูลค่าเพิ่ม"
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 3,
                            className: "px-1 mb-2",
                            children: /*#__PURE__*/ _jsx(Select, {
                                as: "select",
                                name: "qr_quotation_vat",
                                onChange: function(e) {
                                    setTypeVat(e.value);
                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                        qr_quotation_vat: e.value
                                    }));
                                },
                                options: optionsMstVat,
                                value: optionsMstVat.filter(function(item) {
                                    return item.value === typeVat;
                                }),
                                isDisabled: editDisabled ? true : false
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 4,
                            className: "px-1 mb-2",
                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                name: "qr_quotation_totalvat",
                                className: "text-end",
                                placeholder: "ภาษีมูลค่าเพิ่ม",
                                "aria-label": "Disabled Total Vat",
                                value: NumberFormat(totalVat, 2),
                                disabled: true,
                                readOnly: true
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: "auto",
                            className: "pl-1 mb-2",
                            children: "บาท"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    className: "align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            className: "text-end pr-1 mb-2",
                            children: "หัก ณ ที่จ่าย"
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 3,
                            className: "px-1 mb-2",
                            children: /*#__PURE__*/ _jsx(Select, {
                                as: "select",
                                name: "qr_quotation_tax",
                                onChange: function(e) {
                                    setTypeTax(e.value);
                                    setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                        qr_quotation_tax: e.value
                                    }));
                                },
                                options: optionsMstTax,
                                value: optionsMstTax.filter(function(item) {
                                    return item.value === typeTax;
                                }),
                                isDisabled: editDisabled ? true : false
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 4,
                            className: "px-1 mb-2",
                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                name: "qr_quotation_totaltax",
                                className: "text-end",
                                placeholder: "หัก ณ ที่จ่าย",
                                "aria-label": "Disabled Total Tax",
                                value: NumberFormat(totalTax, 2),
                                disabled: true,
                                readOnly: true
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: "auto",
                            className: "pl-1 mb-2",
                            children: "บาท"
                        })
                    ]
                })
            ]
        });
    };
    var handlePreviewFile = function(e) {
        if (e.target.files[0]) {
            var formData = new FormData();
            formData.append("upload_quotation", e.target.files[0]);
            dispatch(updateQuotationFile(formData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setTextImg("doc");
        }
    };
    useEffect(function() {
        setIsLoading(updateQuotationFileReducer.isFetching || getQuotationFileByIdReducer.isFetching);
        if (updateQuotationFileReducer.data && !updateQuotationFileReducer.isError) {
            var updatedData2 = updateQuotationFileReducer.data.data;
            dispatch(clearUpdateQuotationFile());
            if (updatedData2 && updatedData2.length > 0) {
                var qrFileUrl = "";
                var qrFileName = "";
                if (updatedData2[0]) {
                    qrFileUrl = updatedData2[0].imgFilePath;
                    qrFileName = updatedData2[0].imgoriginalname;
                } else {
                    qrFileUrl = updatedData2.imgFilePath;
                    qrFileName = updatedData2.imgoriginalname;
                }
                setFileUpLoad(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            qr_file_quotid: quoteId && quoteId != "" && quoteId != null ? parseInt(quoteId, 10) : 0,
                            qr_file_crebyid: adminInfo && adminInfo.userId && adminInfo.userId != "" && adminInfo.userId != null ? parseInt(adminInfo.userId, 10) : 0,
                            qr_file_url: qrFileUrl,
                            qr_file_name: qrFileName,
                            rowId: nanoid(),
                            isDelete: true,
                            qr_file_chk: "new_file"
                        }
                    ]);
                });
                setIsUpfile(true);
            }
        }
        if (getQuotationFileByIdReducer.data && !getQuotationFileByIdReducer.isError) {
            var datas = getQuotationFileByIdReducer.data.data;
            dispatch(clearGetQuotationFileById());
            if (datas && datas.length > 0) {
                setFileUpLoad(function(prev) {
                    return _to_consumable_array(prev).concat(_to_consumable_array(datas.map(function(item) {
                        return _object_spread_props(_object_spread({}, item), {
                            rowId: nanoid(),
                            isDelete: true,
                            qr_file_chk: "old_file"
                        });
                    })));
                });
                setIsUpfile(true);
            }
        }
    }, [
        updateQuotationFileReducer,
        getQuotationFileByIdReducer
    ]);
    useEffect(function() {
        if (partnerData) {
            var totalPriceNew = 0;
            var typeDisNew = 0;
            var discountNew = 0;
            var disRealNew = 0;
            var disPriceNew = 0;
            var taxNew = 0;
            var totalTaxNew = 0;
            var vatNew = 0;
            var totalVatNew = 0;
            var totalNetNew = 0;
            if (partnerData.qr_quotation_totalprice && partnerData.qr_quotation_totalprice >= 0) {
                setSumPreDisC(partnerData.qr_quotation_totalprice);
                totalPriceNew = parseFloat(partnerData.qr_quotation_totalprice);
            }
            if (partnerData.qr_quotation_discounttype && partnerData.qr_quotation_discounttype >= 0) {
                typeDisNew = parseInt(partnerData.qr_quotation_discounttype, 10);
                setTypeDisC(typeDisNew);
            }
            if (partnerData.qr_quotation_discount && partnerData.qr_quotation_discount >= 0) {
                discountNew = parseFloat(partnerData.qr_quotation_discount);
                setAmountDisC(discountNew);
            }
            if (partnerData.qr_quotation_tax && partnerData.qr_quotation_tax > 0) {
                taxNew = parseFloat(partnerData.qr_quotation_tax);
                setTypeTax(taxNew);
            }
            if (partnerData.qr_quotation_vat && partnerData.qr_quotation_vat > 0) {
                vatNew = parseFloat(partnerData.qr_quotation_vat);
                setTypeVat(vatNew);
            }
            if (partnerData.qr_quotation_totalprice && partnerData.qr_quotation_totalprice >= 0) {
                setSumPreDisC(partnerData.qr_quotation_totalprice);
                totalPriceNew = parseFloat(partnerData.qr_quotation_totalprice);
            }
            if (totalPriceNew > 0) {
                if (typeDisNew == 2 && discountNew > 0.001) {
                    disRealNew = parseFloat(totalPriceNew) * parseFloat(discountNew) / 100;
                } else if (discountNew > 0.001) {
                    disRealNew = parseFloat(discountNew);
                }
                if (disRealNew > 0.001) {
                    disPriceNew = parseFloat(totalPriceNew) - parseFloat(disRealNew);
                } else {
                    disPriceNew = parseFloat(totalPriceNew);
                }
                if (taxNew > 0 && disPriceNew > 0.001) {
                    totalTaxNew = parseFloat(disPriceNew) * parseFloat(taxNew) / 100;
                }
                if (vatNew > 0 && disPriceNew > 0.001) {
                    totalVatNew = parseFloat(disPriceNew) * parseFloat(vatNew) / 100;
                }
                totalNetNew = parseFloat(disPriceNew) - parseFloat(totalTaxNew) + parseFloat(totalVatNew);
            }
            setSumTotal(totalNetNew);
            setTotalDisC(disRealNew);
            setPreTax(disPriceNew);
            setTotalVat(totalVatNew);
            setTotalTax(totalTaxNew);
            setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                qr_quotation_discountreal: disRealNew && disRealNew >= 0 ? parseFloat(disRealNew) : 0,
                qr_quotation_pricediscount: disPriceNew && disPriceNew >= 0 ? parseFloat(disPriceNew) : 0,
                qr_quotation_totaltax: totalTaxNew && totalTaxNew >= 0 ? parseFloat(totalTaxNew) : 0,
                qr_quotation_totalvat: totalVatNew && totalVatNew >= 0 ? parseFloat(totalVatNew) : 0,
                qr_quotation_totalnet: totalNetNew && totalNetNew >= 0 ? parseFloat(totalNetNew) : 0
            }));
        }
        if (fileUpLoad && fileUpLoad.length > 0 && isUpfile) {
            //console.log("fileUpLoad : ",fileUpLoad);
            setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                qr_file: fileUpLoad && fileUpLoad.length > 0 ? fileUpLoad : []
            }));
            setIsUpfile(false);
        }
    }, [
        partnerData,
        fileUpLoad,
        isUpfile
    ]);
    var removeFile = function(rowIdToRemove, idFile) {
        if (idFile && idFile > 0) {
            setFileDelOld(function(prevDelOld) {
                var updated = _to_consumable_array(prevDelOld).concat([
                    {
                        qr_file_id: idFile
                    }
                ]);
                if (quoteId && quoteId !== "" && quoteId !== null && quoteId > 0) {
                    setPartnerData(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            qr_file_delete: updated
                        });
                    });
                }
                return updated;
            });
        }
        setFileUpLoad(function(prev) {
            return prev.filter(function(item) {
                return item.rowId !== rowIdToRemove;
            });
        });
    };
    useEffect(function() {
        getData();
    }, []);
    return /*#__PURE__*/ _jsx(Card, {
        className: "card-st-1 mb-4",
        children: /*#__PURE__*/ _jsxs(CardBody, {
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    className: "align-items-start justify-content-start",
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            className: "d-block d-md-none",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "fs-18 fw-bold",
                                children: "สรุปข้อมูล"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            className: "d-block d-md-none",
                            children: boxSumResult()
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            className: "d-block d-md-none",
                            children: boxShowResult(sumTotal)
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            className: "d-none d-md-block",
                            children: /*#__PURE__*/ _jsxs(Stack, {
                                direction: "horizontal",
                                gap: 3,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "py-2 px-0 align-self-start",
                                        style: {
                                            minWidth: 100
                                        },
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "fs-18 fw-bold",
                                            children: "สรุปข้อมูล"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "py-2 px-0 ms-auto align-self-start",
                                        children: boxSumResult()
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "py-2 px-0 align-self-start",
                                        style: {
                                            minWidth: 200
                                        },
                                        children: boxShowResult(sumTotal)
                                    })
                                ]
                            })
                        })
                    ]
                }),
                collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("hr", {
                            className: "my-4",
                            style: {
                                opacity: 0.1
                            }
                        }),
                        /*#__PURE__*/ _jsx(Row, {
                            children: /*#__PURE__*/ _jsxs(Col, {
                                xs: 12,
                                md: 6,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 fw-bold",
                                        children: "หมายเหตุ"
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: /*#__PURE__*/ _jsx(Form.Control, {
                                            as: "textarea",
                                            rows: 3,
                                            name: "qr_quotation_ramark",
                                            placeholder: "หมายเหตุ",
                                            style: {
                                                resize: "none"
                                            },
                                            onChange: function(e) {
                                                setRemark(e.target.value);
                                                setPartnerData(_object_spread_props(_object_spread({}, partnerData), {
                                                    qr_quotation_ramark: e.target.value
                                                }));
                                            },
                                            value: partnerData.qr_quotation_ramark != null && partnerData.qr_quotation_ramark != "" && partnerData.qr_quotation_ramark != "null" ? partnerData.qr_quotation_ramark.trim() : "",
                                            disabled: editDisabled ? true : false,
                                            readOnly: editDisabled ? true : false
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("hr", {
                            className: "my-4",
                            style: {
                                opacity: 0.1
                            }
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fw-bold fs-18 mb-3",
                            children: "ไฟล์แนบ"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "pb-4",
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn  btn-upload-file mb-4",
                                    onClick: function(e) {
                                        return document.getElementById("fileUpload").click();
                                    },
                                    disabled: statusQuot >= 3 ? false : true,
                                    children: "อัพโหลดไฟล์แนบ"
                                }),
                                /*#__PURE__*/ _jsx("input", {
                                    type: "file",
                                    name: "",
                                    className: "fileUpload hide-input",
                                    id: "fileUpload",
                                    accept: ".pdf",
                                    onChange: function(e) {
                                        handlePreviewFile(e);
                                    }
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mt-4",
                                    children: fileUpLoad && fileUpLoad.length > 0 ? /*#__PURE__*/ _jsx(Stack, {
                                        direction: "horizontal",
                                        gap: 2,
                                        sx: {
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                            flexWrap: "wrap"
                                        },
                                        children: fileUpLoad.map(function(item, index) {
                                            return /*#__PURE__*/ _jsxs("div", {
                                                className: "mb-2",
                                                style: {
                                                    alignContent: "center",
                                                    border: "1px dashed rgba(203, 208, 220, 1)",
                                                    borderRadius: 10,
                                                    height: 200,
                                                    width: 200
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "text-center",
                                                        children: /*#__PURE__*/ _jsx(DownloadFile, {
                                                            urlPath: item.qr_file_url,
                                                            fileName: item.qr_file_name,
                                                            showIconFile: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "text-center",
                                                        children: /*#__PURE__*/ _jsx(DownloadFile, {
                                                            urlPath: item.qr_file_url,
                                                            fileName: item.qr_file_name,
                                                            showText: true
                                                        })
                                                    }),
                                                    item.isDelete ? /*#__PURE__*/ _jsx("div", {
                                                        className: "text-center",
                                                        children: /*#__PURE__*/ _jsx(ButtonMui, {
                                                            size: "small",
                                                            variant: "contained",
                                                            color: "error",
                                                            startIcon: /*#__PURE__*/ _jsx(DeleteIcon, {}),
                                                            onClick: function() {
                                                                return removeFile(item.rowId, item.qr_file_id);
                                                            },
                                                            children: "ลบ"
                                                        })
                                                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                                ]
                                            });
                                        })
                                    }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(_Fragment, {})
            ]
        })
    });
}
function BoxSubmitFrom(_param) {
    var partnerData = _param.partnerData, setPartnerData = _param.setPartnerData, props = _object_without_properties(_param, [
        "partnerData",
        "setPartnerData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var _useParams = useParams(), quoteId = _useParams.quoteId, contractId = _useParams.contractId;
    var statusQuot = props.statusQuot && props.statusQuot > 0 ? props.statusQuot : 0;
    var mode = props.mode && props.mode != "" && props.mode != null ? props.mode : "create";
    var editDisabled = props.editDisabled ? props.editDisabled : false;
    var quoteCode = props.quoteCode && props.quoteCode != "" && props.quoteCode != null ? props.quoteCode : "";
    var chkDisabled = props.chkDisabled ? props.chkDisabled : false;
    var partnerInfoNew = props.partnerInfoNew ? props.partnerInfoNew : {};
    var listData = props.listData ? props.listData : [];
    var fileData = props.fileData ? props.fileData : [];
    var listDataDel = props.listDataDel ? props.listDataDel : [];
    var fileDataDel = props.fileDataDel ? props.fileDataDel : [];
    var _useState = _sliced_to_array(useState(), 2), dataFrom = _useState[0], setDataFrom = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), draftShow = _useState1[0], setDraftShow = _useState1[1];
    var handleDraftShow = function() {
        return setDraftShow(true);
    };
    var handleDraftClose = function() {
        return setDraftShow(false);
    };
    var _useState2 = _sliced_to_array(useState(false), 2), sendApproveShow = _useState2[0], setSendApproveShow = _useState2[1];
    var handleSendApproveShow = function() {
        return setSendApproveShow(true);
    };
    var handleSendApproveClose = function() {
        return setSendApproveShow(false);
    };
    var _useState3 = _sliced_to_array(useState(false), 2), approveShow = _useState3[0], setApproveShow = _useState3[1];
    var handleApproveShow = function() {
        return setApproveShow(true);
    };
    var handleApproveClose = function() {
        return setApproveShow(false);
    };
    var _useState4 = _sliced_to_array(useState(false), 2), noApproveShow = _useState4[0], setNoApproveShow = _useState4[1];
    var handleNoApproveShow = function() {
        return setNoApproveShow(true);
    };
    var handleNoApproveClose = function() {
        return setNoApproveShow(false);
    };
    var _useState5 = _sliced_to_array(useState(false), 2), isEditDataShow = _useState5[0], setIsEditDataShow = _useState5[1];
    var handleIsEditDataShow = function() {
        return setIsEditDataShow(true);
    };
    var handleIsEditDataClose = function() {
        return setIsEditDataShow(false);
    };
    var _useState6 = _sliced_to_array(useState(false), 2), saveDataShow = _useState6[0], setSaveDataShow = _useState6[1];
    var handleSaveDataShow = function() {
        return setSaveDataShow(true);
    };
    var handleSaveDataClose = function() {
        return setSaveDataShow(false);
    };
    var _useState7 = _sliced_to_array(useState(false), 2), notifyBoxShow = _useState7[0], setNotifyBoxShow = _useState7[1];
    var handleNotifyBoxShow = function() {
        return setNotifyBoxShow(true);
    };
    var handleNotifyClose = function() {
        return setNotifyBoxShow(false);
    };
    var _useState8 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState8[0], setModalsuccess = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState9[0], setModalAlert = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), msgText = _useState10[0], setMsgText = _useState10[1];
    useEffect(function() {
        var userId = adminInfo && adminInfo.userId && adminInfo.userId != "" && adminInfo.userId != null ? parseInt(adminInfo.userId, 10) : 0;
        if (partnerData) {
            var qrFileNewSet = [];
            var qrFileDelNewSet = [];
            var qrDetailDelNewSet = [];
            if (quoteId && quoteId != "" && quoteId != null && quoteId > 0) {
                if (partnerData.qr_file && partnerData.qr_file.length > 0) {
                    qrFileNewSet = partnerData.qr_file.map(function(item) {
                        return item.qr_file_id && item.qr_file_id > 0 ? {
                            qr_file_id: item.qr_file_id ? parseInt(item.qr_file_id, 10) : 0,
                            qr_file_quotid: item.qr_file_quotid ? filterTextAndNum(item.qr_file_quotid, 1) : parseInt(quoteId, 10),
                            qr_file_url: item.qr_file_url ? filterTextAndNum(item.qr_file_url) : "",
                            qr_file_name: item.qr_file_name ? filterTextAndNum(item.qr_file_name) : "",
                            qr_file_crebyid: item.qr_file_crebyid ? filterTextAndNum(item.qr_file_crebyid, 1) : userId
                        } : {
                            qr_file_quotid: quoteId && quoteId != "" && quoteId != null ? parseInt(quoteId, 10) : 0,
                            qr_file_url: item.qr_file_url ? filterTextAndNum(item.qr_file_url) : "",
                            qr_file_name: item.qr_file_name ? filterTextAndNum(item.qr_file_name) : "",
                            qr_file_crebyid: item.qr_file_crebyid ? filterTextAndNum(item.qr_file_crebyid, 1) : userId
                        };
                    });
                }
                if (partnerData.qr_file_delete && partnerData.qr_file_delete.length > 0) {
                    qrFileDelNewSet = partnerData.qr_file_delete.map(function(item) {
                        return {
                            qr_file_id: item.qr_file_id ? parseInt(item.qr_file_id, 10) : 0
                        };
                    });
                }
                if (partnerData.qr_detail_delete && partnerData.qr_detail_delete.length > 0) {
                    qrDetailDelNewSet = partnerData.qr_detail_delete.map(function(item) {
                        return {
                            qr_detail_id: item.qr_detail_id ? parseInt(item.qr_detail_id, 10) : 0
                        };
                    });
                }
            } else {
                if (partnerData.qr_file && partnerData.qr_file.length > 0) {
                    qrFileNewSet = partnerData.qr_file.map(function(item) {
                        return {
                            qr_file_url: item.qr_file_url ? filterTextAndNum(item.qr_file_url) : "",
                            qr_file_name: item.qr_file_name ? filterTextAndNum(item.qr_file_name) : "",
                            qr_file_crebyid: item.qr_file_crebyid ? filterTextAndNum(item.qr_file_crebyid, 1) : userId
                        };
                    });
                }
            }
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    qr_quotation_memid: partnerData.qr_quotation_memid ? filterTextAndNum(partnerData.qr_quotation_memid, 2) : 0,
                    qr_quotation_businessid: partnerData.qr_quotation_businessid ? filterTextAndNum(partnerData.qr_quotation_businessid, 1) : 0,
                    qr_quotation_contid: partnerData.qr_quotation_contid ? filterTextAndNum(partnerData.qr_quotation_contid, 2) : 0,
                    qr_quotation_refercode: partnerData.qr_quotation_refercode ? filterTextAndNum(partnerData.qr_quotation_refercode) : "",
                    qr_quotation_issuedate: partnerData.qr_quotation_issuedate && partnerData.qr_quotation_issuedate != "" ? moment(partnerData.qr_quotation_issuedate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "",
                    qr_quotation_expiredate: partnerData.qr_quotation_expiredate && partnerData.qr_quotation_expiredate != "" ? moment(partnerData.qr_quotation_expiredate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "",
                    qr_quotation_businesstype: partnerData.qr_quotation_businesstype ? filterTextAndNum(partnerData.qr_quotation_businesstype, 1) : 0,
                    qr_quotation_taxid: partnerData.qr_quotation_taxid ? filterTextAndNum(partnerData.qr_quotation_taxid) : "",
                    qr_quotation_categoryid: partnerData.qr_quotation_categoryid ? filterTextAndNum(partnerData.qr_quotation_categoryid, 2) : 0,
                    qr_quotation_comprefixid: partnerData.qr_quotation_comprefixid ? filterTextAndNum(partnerData.qr_quotation_comprefixid, 2) : 0,
                    qr_quotation_comprefixname: partnerData.qr_quotation_comprefixname ? filterTextAndNum(partnerData.qr_quotation_comprefixname) : "",
                    qr_quotation_name: partnerData.qr_quotation_name ? filterTextAndNum(partnerData.qr_quotation_name) : "",
                    qr_quotation_suffixname: partnerData.qr_quotation_suffixname ? filterTextAndNum(partnerData.qr_quotation_suffixname) : "",
                    qr_quotation_vatcode: partnerData.qr_quotation_vatcode ? filterTextAndNum(partnerData.qr_quotation_vatcode) : "",
                    qr_quotation_branchname: partnerData.qr_quotation_branchname ? filterTextAndNum(partnerData.qr_quotation_branchname) : "",
                    qr_quotation_prefixid: partnerData.qr_quotation_prefixid ? filterTextAndNum(partnerData.qr_quotation_prefixid, 2) : 0,
                    qr_quotation_fname: partnerData.qr_quotation_fname ? filterTextAndNum(partnerData.qr_quotation_fname) : "",
                    qr_quotation_lname: partnerData.qr_quotation_lname ? filterTextAndNum(partnerData.qr_quotation_lname) : "",
                    qr_quotation_address: partnerData.qr_quotation_address ? filterTextAndNum(partnerData.qr_quotation_address) : "",
                    qr_quotation_provinceid: partnerData.qr_quotation_provinceid ? filterTextAndNum(partnerData.qr_quotation_provinceid, 2) : 0,
                    qr_quotation_subprovinceid: partnerData.qr_quotation_subprovinceid ? filterTextAndNum(partnerData.qr_quotation_subprovinceid, 2) : 0,
                    qr_quotation_districtid: partnerData.qr_quotation_districtid ? filterTextAndNum(partnerData.qr_quotation_districtid, 2) : 0,
                    qr_quotation_zipcodeid: partnerData.qr_quotation_zipcodeid ? filterTextAndNum(partnerData.qr_quotation_zipcodeid) : "",
                    qr_quotation_mainfname: partnerData.qr_quotation_mainfname ? filterTextAndNum(partnerData.qr_quotation_mainfname) : "",
                    qr_quotation_mainlname: partnerData.qr_quotation_mainlname ? filterTextAndNum(partnerData.qr_quotation_mainlname) : "",
                    qr_quotation_mainphone: partnerData.qr_quotation_mainphone ? filterTextAndNum(partnerData.qr_quotation_mainphone) : "",
                    qr_quotation_mainemail: partnerData.qr_quotation_mainemail ? filterTextAndNum(partnerData.qr_quotation_mainemail) : "",
                    qr_quotation_vattype: partnerData.qr_quotation_vattype ? filterTextAndNum(partnerData.qr_quotation_vattype, 2) : 0,
                    qr_quotation_paytype: partnerData.qr_quotation_paytype ? filterTextAndNum(partnerData.qr_quotation_paytype, 2) : 0,
                    qr_quotation_totalprice: partnerData.qr_quotation_totalprice ? filterTextAndNum(partnerData.qr_quotation_totalprice, 2) : 0,
                    qr_quotation_discounttype: partnerData.qr_quotation_discounttype ? filterTextAndNum(partnerData.qr_quotation_discounttype, 2) : 0,
                    qr_quotation_discount: partnerData.qr_quotation_discount ? filterTextAndNum(partnerData.qr_quotation_discount, 2) : 0,
                    qr_quotation_discountreal: partnerData.qr_quotation_discountreal ? filterTextAndNum(partnerData.qr_quotation_discountreal, 2) : 0,
                    qr_quotation_pricediscount: partnerData.qr_quotation_pricediscount ? filterTextAndNum(partnerData.qr_quotation_pricediscount, 2) : 0,
                    qr_quotation_tax: partnerData.qr_quotation_tax ? filterTextAndNum(partnerData.qr_quotation_tax, 2) : 0,
                    qr_quotation_vat: partnerData.qr_quotation_vat ? filterTextAndNum(partnerData.qr_quotation_vat, 2) : 0,
                    qr_quotation_totaltax: partnerData.qr_quotation_totaltax ? filterTextAndNum(partnerData.qr_quotation_totaltax, 2) : 0,
                    qr_quotation_totalvat: partnerData.qr_quotation_totalvat ? filterTextAndNum(partnerData.qr_quotation_totalvat, 2) : 0,
                    qr_quotation_totalnet: partnerData.qr_quotation_totalnet ? filterTextAndNum(partnerData.qr_quotation_totalnet, 2) : 0,
                    qr_quotation_status: partnerData.qr_quotation_status ? filterTextAndNum(partnerData.qr_quotation_status, 1) : 0,
                    qr_quotation_ramark: partnerData.qr_quotation_ramark ? filterTextAndNum(partnerData.qr_quotation_ramark) : "",
                    // qr_quotation_tag: partnerData.qr_quotation_tag ? partnerData.qr_quotation_tag : "",
                    qr_quotation_crebyid: partnerData.qr_quotation_crebyid ? filterTextAndNum(partnerData.qr_quotation_crebyid, 1) : userId,
                    qr_file: qrFileNewSet && qrFileNewSet.length > 0 ? qrFileNewSet : [],
                    qr_detail_delete: qrDetailDelNewSet && qrDetailDelNewSet.length > 0 ? qrDetailDelNewSet : [],
                    qr_file_delete: qrFileDelNewSet && qrFileDelNewSet.length > 0 ? qrFileDelNewSet : []
                });
            });
        }
        if (listData && listData.length > 0) {
            var qrDetailNewSet = [];
            if (quoteId && quoteId != "" && quoteId != null && quoteId > 0) {
                qrDetailNewSet = listData.map(function(item) {
                    return _object_spread_props(_object_spread({}, item.qr_detail_id && {
                        qr_detail_id: item.qr_detail_id ? parseInt(item.qr_detail_id, 10) : 0
                    }), {
                        qr_detail_quotid: item.qr_detail_quotid ? parseInt(item.qr_detail_quotid, 10) : parseInt(quoteId, 10),
                        qr_detail_name: item.qr_detail_name ? filterTextAndNum(item.qr_detail_name) : "",
                        qr_detail_unit: item.qr_detail_unit ? filterTextAndNum(item.qr_detail_unit) : "",
                        qr_detail_amount: item.qr_detail_amount ? parseInt(item.qr_detail_amount, 10) : 0,
                        qr_detail_price: item.qr_detail_price ? parseFloat(item.qr_detail_price) : 0,
                        qr_detail_discounttype: item.qr_detail_discounttype ? parseInt(item.qr_detail_discounttype, 10) : 0,
                        qr_detail_discount: item.qr_detail_discount ? parseFloat(item.qr_detail_discount) : 0,
                        qr_detail_discountreal: item.qr_detail_discountreal ? parseFloat(item.qr_detail_discountreal) : 0,
                        qr_detail_pricediscount: item.qr_detail_pricediscount ? parseFloat(item.qr_detail_pricediscount) : 0,
                        qr_detail_vat: item.qr_detail_vat ? parseFloat(item.qr_detail_vat) : 0,
                        qr_detail_vatprice: item.qr_detail_vatprice ? parseFloat(item.qr_detail_vatprice) : 0,
                        qr_detail_net: item.qr_detail_net ? parseFloat(item.qr_detail_net) : 0,
                        qr_detail_remark: item.qr_detail_remark ? filterTextAndNum(item.qr_detail_remark) : "",
                        qr_detail_crebyid: item && item.qr_detail_crebyid && item.qr_detail_crebyid > 0 ? parseInt(item.qr_detail_crebyid, 10) : userId
                    });
                });
            } else {
                qrDetailNewSet = listData.map(function(item) {
                    return {
                        qr_detail_name: item.qr_detail_name && item.qr_detail_name != "" && item.qr_detail_name != null ? item.qr_detail_name : "",
                        qr_detail_unit: item.qr_detail_unit && item.qr_detail_unit != "" && item.qr_detail_unit != null ? item.qr_detail_unit : "",
                        qr_detail_amount: item.qr_detail_amount && item.qr_detail_amount > 0 ? parseInt(item.qr_detail_amount, 10) : 0,
                        qr_detail_price: item.qr_detail_price && item.qr_detail_price > 0 ? parseFloat(item.qr_detail_price) : 0,
                        qr_detail_discounttype: item.qr_detail_discounttype && item.qr_detail_discounttype > 0 ? parseInt(item.qr_detail_discounttype, 10) : 0,
                        qr_detail_discount: item.qr_detail_discount && item.qr_detail_discount > 0 ? parseFloat(item.qr_detail_discount) : 0,
                        qr_detail_discountreal: item.qr_detail_discountreal && item.qr_detail_discountreal > 0 ? parseFloat(item.qr_detail_discountreal) : 0,
                        qr_detail_pricediscount: item.qr_detail_pricediscount && item.qr_detail_pricediscount > 0 ? parseFloat(item.qr_detail_pricediscount) : 0,
                        qr_detail_vat: item.qr_detail_vat && item.qr_detail_vat > 0 ? parseFloat(item.qr_detail_vat) : 0,
                        qr_detail_vatprice: item.qr_detail_vatprice && item.qr_detail_vatprice > 0 ? parseFloat(item.qr_detail_vatprice) : 0,
                        qr_detail_net: item.qr_detail_net && item.qr_detail_net > 0 ? parseFloat(item.qr_detail_net) : 0,
                        qr_detail_remark: item.qr_detail_remark && item.qr_detail_remark != "" && item.qr_detail_remark != null ? item.qr_detail_remark : "",
                        qr_detail_crebyid: item.qr_detail_crebyid && item.qr_detail_crebyid > 0 ? parseInt(item.qr_detail_crebyid, 10) : userId
                    };
                });
            }
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    qr_detail: qrDetailNewSet && qrDetailNewSet.length > 0 ? qrDetailNewSet : []
                });
            });
        } else {
            setDataFrom(function(dataFrom) {
                return _object_spread_props(_object_spread({}, dataFrom), {
                    qr_detail: []
                });
            });
        }
    }, [
        partnerData,
        listData
    ]);
    var componentRef = useRef();
    var handlePrint = useReactToPrint({
        documentTitle: "ใบเสนอราคา".concat(moment().format("DDMMYYYYHHmmss")),
        content: function() {
            return componentRef.current;
        }
    });
    if (!window.Buffer) window.Buffer = Buffer;
    var handleDownload = function() {
        var _ref = _async_to_generator(function() {
            var blob, fileName, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            pdf(/*#__PURE__*/ _jsx(ContractDocument, {
                                dataFrom: dataFrom,
                                ptInfoNew: partnerInfoNew,
                                typeDocPrint: 1
                            })).toBlob()
                        ];
                    case 1:
                        blob = _state.sent();
                        // ตั้งชื่อไฟล์
                        fileName = "ใบเสนอราคา_".concat(moment().format("DDMMYYYYHHmmss"), ".pdf");
                        // ดาวน์โหลด
                        saveAs(blob, fileName);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error("เกิดข้อผิดพลาดในการสร้าง PDF:", error);
                        alert("ไม่สามารถสร้างไฟล์ PDF ได้");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    var chackFillSave = function() {
        var statusData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, dataSave = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        try {
            //console.log("dataSave : ",dataSave);
            var errMsg = "";
            if (statusData && statusData > 0) {
                if (dataSave) {
                    if (!dataSave.qr_quotation_businessid || dataSave.qr_quotation_businessid <= 0) {
                        errMsg += "กรุณากรอกหรือเลือกชื่อลูกค้าที่จะสร้างใบเสนอราคา<br><br>";
                    }
                    if (!dataSave.qr_quotation_issuedate || dataSave.qr_quotation_issuedate == "" || dataSave.qr_quotation_issuedate == null) {
                        errMsg += "กรุณากรอกวันที่ออกเอกสาร<br><br>";
                    }
                    if (!dataSave.qr_quotation_expiredate || dataSave.qr_quotation_expiredate == "" || dataSave.qr_quotation_expiredate == null) {
                        errMsg += "กรุณากรอกวันที่เอกสารหมดอายุ<br><br>";
                    }
                    if (!dataSave.qr_quotation_vattype || dataSave.qr_quotation_vattype <= 0) {
                        errMsg += "กรุณาเลือกประเภทราคา<br><br>";
                    }
                    if (!dataSave.qr_quotation_paytype || dataSave.qr_quotation_paytype <= 0) {
                        errMsg += "กรุณาเลือกประเภทการชำระเงิน<br><br>";
                    }
                    if (!dataSave.qr_detail || dataSave.qr_detail.length <= 0) {
                        errMsg += "กรุณาเพิ่มรายการใบเสนอราคา อย่างน้อย 1 รายการ<br><br>";
                    }
                } else {
                    errMsg = "กรุณากรอกหรือเลือกชื่อลูกค้าที่จะสร้างใบเสนอราคา<br><br>" + "กรุณากรอกวันที่ออกเอกสาร<br><br>" + "กรุณากรอกวันที่เอกสารหมดอายุ<br><br>" + "กรุณาเลือกประเภทราคา<br><br>" + "กรุณาเลือกประเภทการชำระเงิน<br><br>" + "กรุณาเพิ่มรายการใบเสนอราคา อย่างน้อย 1 รายการ";
                }
                if (errMsg && errMsg != "" && errMsg != null) {
                    setMsgText(errMsg);
                    // setModalAlert((prev) => (
                    // { 
                    //     ...prev, 
                    //     open: true
                    // }));
                    handleNotifyBoxShow();
                } else {
                    if (statusData == 1) {
                        handleDraftShow();
                    } else if (statusData == 2) {
                        handleSendApproveShow();
                    } else {
                        handleSaveDataShow();
                    }
                }
            }
        } catch (error) {
            console.error("Error : ", error);
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-1 mb-4",
                children: /*#__PURE__*/ _jsx(CardBody, {
                    children: /*#__PURE__*/ _jsxs(Row, {
                        className: "align-items-center justify-content-between",
                        children: [
                            statusQuot && statusQuot >= 3 ? /*#__PURE__*/ _jsx(Col, {
                                xs: 6,
                                md: 6,
                                lg: 4,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "d-flex gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Button, {
                                            variant: "",
                                            className: "btn-print-info mb-xs-2 mb-lg-0",
                                            onClick: handleDownload,
                                            children: [
                                                /*#__PURE__*/ _jsx(PrintIcon, {
                                                    className: "mr-1"
                                                }),
                                                "พิมพ์สัญญา"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            style: {
                                                display: "none"
                                            },
                                            children: /*#__PURE__*/ _jsx(PagePrint, {
                                                ref: componentRef,
                                                dataFrom: dataFrom,
                                                partnerInfoNew: partnerInfoNew,
                                                typeDocPrint: 1
                                            })
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ _jsx(Col, {
                                xs: 3,
                                md: 6,
                                lg: 4
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: "auto",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "d-flex gap-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            variant: "outline-secondary",
                                            href: "/quotation",
                                            className: "mb-xs-2 mb-lg-0",
                                            children: "ยกเลิก"
                                        }),
                                        statusQuot && statusQuot == 5 ? /*#__PURE__*/ _jsx(_Fragment, {}) : statusQuot && statusQuot >= 3 && !chkDisabled ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn-st-7 px-2 mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        handleIsEditDataShow();
                                                    },
                                                    variant: "",
                                                    children: "แก้ไข"
                                                }),
                                                statusQuot != 4 ? // <Button 
                                                //     className="mb-xs-2 mb-lg-0"
                                                //     onClick={() => {
                                                //         // console.log("partnerInfoNew : ",partnerInfoNew);
                                                //         // console.log("dataFrom : ",dataFrom);
                                                //         //handleConfirmShow();
                                                //     }}
                                                //     variant="success"
                                                // >
                                                //     ตอบรับใบเสนอราคา
                                                // </Button>
                                                /*#__PURE__*/ _jsx(_Fragment, {}) : /*#__PURE__*/ _jsx(_Fragment, {})
                                            ]
                                        }) : statusQuot && statusQuot >= 3 && chkDisabled ? /*#__PURE__*/ _jsx(_Fragment, {
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                className: "mb-xs-2 mb-lg-0",
                                                onClick: function() {
                                                    //handleSaveDataShow();
                                                    chackFillSave(statusQuot, dataFrom);
                                                },
                                                variant: "success",
                                                children: "บันทึก"
                                            })
                                        }) : statusQuot && statusQuot == 2 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        handleApproveShow();
                                                    },
                                                    variant: "success",
                                                    children: "อนุมัติ"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn-st-7 px-2 mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        handleNoApproveShow();
                                                    },
                                                    variant: "",
                                                    children: "ไม่อนุมัติ"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn-st-7 px-2 mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        //console.log("dataFrom : ",dataFrom);
                                                        //handleDraftShow();
                                                        chackFillSave(1, dataFrom);
                                                    },
                                                    variant: "",
                                                    children: "บันทึกร่าง"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "mb-xs-2 mb-lg-0",
                                                    onClick: function() {
                                                        //console.log("dataFrom : ",dataFrom);
                                                        //handleSendApproveShow();
                                                        chackFillSave(2, dataFrom);
                                                    },
                                                    variant: "primary",
                                                    children: "ส่งอนุมัติ"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(DraftModal, {
                show: draftShow,
                onHide: handleDraftClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess
            }),
            /*#__PURE__*/ _jsx(SendApproveModal, {
                show: sendApproveShow,
                onHide: handleSendApproveClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess
            }),
            /*#__PURE__*/ _jsx(ApproveModal, {
                show: approveShow,
                onHide: handleApproveClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                quoteCode: quoteCode
            }),
            /*#__PURE__*/ _jsx(NoApproveModal, {
                show: noApproveShow,
                onHide: handleNoApproveClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                quoteCode: quoteCode
            }),
            /*#__PURE__*/ _jsx(IsEditDataModal, {
                show: isEditDataShow,
                onHide: handleIsEditDataClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                onEditFrom: function() {
                    props.setChkDisabled(true);
                    props.setLoadEditF(true);
                    handleIsEditDataClose();
                }
            }),
            /*#__PURE__*/ _jsx(SaveDataModal, {
                show: saveDataShow,
                onHide: handleSaveDataClose,
                setDataFrom: setDataFrom,
                dataFrom: dataFrom,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            }),
            /*#__PURE__*/ _jsx(NotifyModal, {
                show: notifyBoxShow,
                onHide: handleNotifyClose,
                hTitle: "แจ้งเตือน",
                msgText: msgText,
                heightM: 320
            })
        ]
    });
}
function DraftModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var quoteId = useParams().quoteId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var createQuotationReducer = useAppSelector(function(state) {
        return state.createQuotationReducer;
    });
    var updateQuotationReducer = useAppSelector(function(state) {
        return state.updateQuotationReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        if (dataFrom && dataFrom != "" && dataFrom != null) {
            setIsLoading(true);
            var payload = {};
            if (quoteId && quoteId != "" && quoteId != null) {
                payload = _object_spread_props(_object_spread({}, dataFrom), {
                    qr_detail: dataFrom.qr_detail && dataFrom.qr_detail.length > 0 ? dataFrom.qr_detail : [],
                    qr_file: dataFrom.qr_file && dataFrom.qr_file.length > 0 ? dataFrom.qr_file : [],
                    qr_detail_delete: dataFrom.qr_detail_delete && dataFrom.qr_detail_delete.length > 0 ? dataFrom.qr_detail_delete : [],
                    qr_file_delete: dataFrom.qr_file_delete && dataFrom.qr_file_delete.length > 0 ? dataFrom.qr_file_delete : [],
                    qr_quotation_status: 1,
                    qr_quotation_id: parseInt(quoteId, 10)
                });
                dispatch(updateQuotation(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            } else {
                payload = _object_spread_props(_object_spread({}, dataFrom), {
                    qr_detail: dataFrom.qr_detail && dataFrom.qr_detail.length > 0 ? dataFrom.qr_detail : [],
                    qr_file: dataFrom.qr_file && dataFrom.qr_file.length > 0 ? dataFrom.qr_file : [],
                    qr_quotation_status: 1
                });
                //console.log("payload",payload);
                dispatch(createQuotation(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setIsBoxAlert(true);
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(createQuotationReducer.isFetching || updateQuotationReducer.isFetching);
        if (quoteId && quoteId != "" && quoteId != null) {
            if (updateQuotationReducer.data && !updateQuotationReducer.isError) {
                var updatedData = updateQuotationReducer.data.data;
                dispatch(clearUpdateQuotation());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "บันทึกร่างเรียบร้อย",
                            direction: "/quotation"
                        });
                    });
                    setIsBoxAlert(false);
                }
            }
        } else {
            if (createQuotationReducer.data && !createQuotationReducer.isError) {
                var createData = createQuotationReducer.data.data;
                dispatch(clearCreateQuotation());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "บันทึกร่างเรียบร้อย",
                            direction: "/quotation"
                        });
                    });
                    setIsBoxAlert(false);
                }
            }
        }
    }, [
        createQuotationReducer,
        updateQuotationReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "บันทึกร่าง"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะบันทึกร่างใบเสนอราคานี้หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function SendApproveModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var quoteId = useParams().quoteId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var createQuotationReducer = useAppSelector(function(state) {
        return state.createQuotationReducer;
    });
    var updateQuotationReducer = useAppSelector(function(state) {
        return state.updateQuotationReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        if (dataFrom && dataFrom != "" && dataFrom != null) {
            setIsLoading(true);
            var payload = {};
            if (quoteId && quoteId != "" && quoteId != null) {
                payload = _object_spread_props(_object_spread({}, dataFrom), {
                    qr_detail: dataFrom.qr_detail && dataFrom.qr_detail.length > 0 ? dataFrom.qr_detail : [],
                    qr_file: dataFrom.qr_file && dataFrom.qr_file.length > 0 ? dataFrom.qr_file : [],
                    qr_detail_delete: dataFrom.qr_detail_delete && dataFrom.qr_detail_delete.length > 0 ? dataFrom.qr_detail_delete : [],
                    qr_file_delete: dataFrom.qr_file_delete && dataFrom.qr_file_delete.length > 0 ? dataFrom.qr_file_delete : [],
                    qr_quotation_status: 2,
                    qr_quotation_id: parseInt(quoteId, 10)
                });
                dispatch(updateQuotation(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            } else {
                payload = _object_spread_props(_object_spread({}, dataFrom), {
                    qr_detail: dataFrom.qr_detail && dataFrom.qr_detail.length > 0 ? dataFrom.qr_detail : [],
                    qr_file: dataFrom.qr_file && dataFrom.qr_file.length > 0 ? dataFrom.qr_file : [],
                    qr_quotation_status: 2
                });
                //console.log("payload",payload);
                dispatch(createQuotation(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setIsBoxAlert(true);
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(createQuotationReducer.isFetching || updateQuotationReducer.isFetching);
        if (quoteId && quoteId != "" && quoteId != null) {
            if (updateQuotationReducer.data && !updateQuotationReducer.isError) {
                var updatedData = updateQuotationReducer.data.data;
                dispatch(clearUpdateQuotation());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "ส่งอนุมัติเรียบร้อย",
                            direction: "/quotation"
                        });
                    });
                    setIsBoxAlert(false);
                }
            }
        } else {
            if (createQuotationReducer.data && !createQuotationReducer.isError) {
                var createData = createQuotationReducer.data.data;
                dispatch(clearCreateQuotation());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "ส่งอนุมัติเรียบร้อย",
                            direction: "/quotation"
                        });
                    });
                    setIsBoxAlert(false);
                }
            }
        }
    }, [
        createQuotationReducer,
        updateQuotationReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ส่งอนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะส่งอนุมัติใบเสนอราคานี้หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function ApproveModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var quoteCode = props.quoteCode && props.quoteCode != "" && props.quoteCode != null ? props.quoteCode : "";
    return /*#__PURE__*/ _jsx(QuotationStatusModal, {
        show: props.show,
        onHide: props.onHide,
        dataFrom: dataFrom,
        setDataFrom: setDataFrom,
        quoteCode: quoteCode,
        setModalsuccess: props.setModalsuccess,
        mode: "approve" // หรือ "reject"
    });
}
function NoApproveModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var quoteCode = props.quoteCode && props.quoteCode != "" && props.quoteCode != null ? props.quoteCode : "";
    return /*#__PURE__*/ _jsx(QuotationStatusModal, {
        show: props.show,
        onHide: props.onHide,
        dataFrom: dataFrom,
        setDataFrom: setDataFrom,
        quoteCode: quoteCode,
        setModalsuccess: props.setModalsuccess,
        mode: "reject" // หรือ "reject"
    });
}
function IsEditDataModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var quoteId = useParams().quoteId;
    var quoteCode = props.quoteCode && props.quoteCode != "" && props.quoteCode != null ? props.quoteCode : "";
    var handleChange = function(e) {};
    var handleClick = function() {
        props.onEditFrom();
    };
    var handleClose = function() {
        return props.onHide();
    };
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "แก้ไข"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะแก้ไขใบเสนอราคาเลขที่ ",
                                quoteCode,
                                " หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: function() {
                            return handleClick();
                        },
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function SaveDataModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var quoteId = useParams().quoteId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var updateQuotationReducer = useAppSelector(function(state) {
        return state.updateQuotationReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        if (dataFrom && dataFrom != "" && dataFrom != null) {
            setIsLoading(true);
            var payload = {};
            if (quoteId && quoteId != "" && quoteId != null) {
                payload = _object_spread_props(_object_spread({}, dataFrom), {
                    qr_detail: dataFrom.qr_detail && dataFrom.qr_detail.length > 0 ? dataFrom.qr_detail : [],
                    qr_file: dataFrom.qr_file && dataFrom.qr_file.length > 0 ? dataFrom.qr_file : [],
                    qr_detail_delete: dataFrom.qr_detail_delete && dataFrom.qr_detail_delete.length > 0 ? dataFrom.qr_detail_delete : [],
                    qr_file_delete: dataFrom.qr_file_delete && dataFrom.qr_file_delete.length > 0 ? dataFrom.qr_file_delete : [],
                    qr_quotation_status: dataFrom.qr_quotation_status && dataFrom.qr_quotation_status == 4 ? 2 : parseInt(dataFrom.qr_quotation_status, 10),
                    qr_quotation_id: parseInt(quoteId, 10)
                });
                dispatch(updateQuotation(payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            setIsBoxAlert(true);
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateQuotationReducer.isFetching);
        if (quoteId && quoteId != "" && quoteId != null) {
            if (updateQuotationReducer.data && !updateQuotationReducer.isError) {
                var updatedData = updateQuotationReducer.data.data;
                dispatch(clearUpdateQuotation());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "บันทึกเรียบร้อย",
                            direction: "/quotation"
                        });
                    });
                    setIsBoxAlert(false);
                }
            }
        }
    }, [
        updateQuotationReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "บันทึก"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Badge, {
                            bg: "danger-light",
                            text: "dark",
                            style: {
                                fontSize: "16px !important",
                                whiteSpace: "unset !important"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(InfoIcon, {
                                    sx: {
                                        color: "#B00412"
                                    },
                                    className: "mr-2"
                                }),
                                "คุณต้องการที่จะบันทึกใบเสนอราคานี้หรือไม่"
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function QuotationStatusModal(_param) {
    var dataFrom = _param.dataFrom, setDataFrom = _param.setDataFrom, mode = _param.mode, quoteCode = _param.quoteCode, setModalsuccess = _param.setModalsuccess, props = _object_without_properties(_param, [
        "dataFrom",
        "setDataFrom",
        "mode",
        "quoteCode",
        "setModalsuccess"
    ]);
    var quoteId = useParams().quoteId;
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var updateQuotationReducer = useAppSelector(function(state) {
        return state.updateQuotationReducer;
    });
    var updateQuotationStatusReducer = useAppSelector(function(state) {
        return state.updateQuotationStatusReducer;
    });
    var _useState = _sliced_to_array(useState(false), 2), isTriggered = _useState[0], setIsTriggered = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isFinished = _useState1[0], setIsFinished = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), remark = _useState2[0], setRemark = _useState2[1];
    var statusCode = mode === "approve" ? 3 : 4;
    var statusText = mode === "approve" ? "อนุมัติ" : "ไม่อนุมัติ";
    var handleChange = function(e) {
        return setRemark(e.target.value);
    };
    var handleClick = function() {
        if (!dataFrom || !quoteId) return;
        if (mode === "reject" && !remark.trim()) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                title: "กรุณากรอกเหตุผลการไม่อนุมัติ"
            }));
            props.onHide();
            return;
        }
        setIsLoading(true);
        setIsTriggered(true);
        var payload = _object_spread_props(_object_spread({}, dataFrom), {
            qr_file: dataFrom.qr_file || [],
            qr_file_delete: dataFrom.qr_file_delete || [],
            qr_quotation_status: statusCode,
            qr_quotation_id: parseInt(quoteId, 10)
        });
        dispatch(updateQuotation(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var updateStatus = function() {
        if (!quoteId) return;
        var payload = {
            quotationid: parseInt(quoteId, 10),
            quotationstatus: statusCode,
            quotationcomment: mode === "approve" ? "".concat(statusText, "ใบเสนอราคา ").concat(quoteCode) : remark.trim()
        };
        dispatch(updateQuotationStatus(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        props.onHide();
        setIsFinished(true);
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateQuotationReducer.isFetching || updateQuotationStatusReducer.isFetching);
        if (quoteId && updateQuotationReducer.data && !updateQuotationReducer.isError && isTriggered) {
            dispatch(clearUpdateQuotation());
            updateStatus();
            setIsTriggered(false);
        }
        if (quoteId && updateQuotationStatusReducer.data && !updateQuotationStatusReducer.isError && isFinished) {
            dispatch(clearUpdateQuotationStatus());
            setModalsuccess({
                visible: true,
                textsuccess: "".concat(statusText, "ใบเสนอราคาเลขที่ ").concat(quoteCode, " เรียบร้อย"),
                direction: "/quotation"
            });
            setIsFinished(false);
        }
    }, [
        updateQuotationReducer,
        updateQuotationStatusReducer,
        isTriggered,
        isFinished
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, props), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsxs(Modal.Title, {
                    children: [
                        statusText,
                        "ใบเสนอราคา"
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: mode === "reject" ? /*#__PURE__*/ _jsx(Col, {
                    xs: 12,
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "เหตุผลการไม่อนุมัติ ",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "span-red-gb",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                as: "textarea",
                                rows: 3,
                                name: "remark_noapprove",
                                placeholder: "กรอกคำอธิบาย",
                                style: {
                                    resize: "none"
                                },
                                onChange: handleChange
                            })
                        ]
                    })
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "alert alert-danger text-break px-2 m-0",
                    role: "alert",
                    children: [
                        /*#__PURE__*/ _jsx(InfoIcon, {
                            sx: {
                                color: "#B00412"
                            },
                            className: "mr-2 text-break"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "text-dark fw-bold",
                            children: [
                                "คุณต้องการที่จะอนุมัติใบเสนอราคาเลขที่ ",
                                quoteCode,
                                " หรือไม่"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
var PagePrint = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var dataFrom = _param.dataFrom, props = _object_without_properties(_param, [
        "dataFrom"
    ]);
    var _dataFrom_qr_detail, _dataFrom_qr_detail1, _dataFrom_qr_detail2, _dataFrom_qr_detail3;
    var rest = _extends({}, _object_destructuring_empty(props));
    var quoteId = useParams().quoteId;
    var typeDocPrint = props.typeDocPrint ? props.typeDocPrint : 1;
    var ptInfoNew = props.partnerInfoNew ? props.partnerInfoNew : {};
    var _useState = _sliced_to_array(useState(""), 2), companyAddress = _useState[0], setCompanyAddress = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), companyName = _useState1[0], setCompanyName = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), companyBranch = _useState2[0], setCompanyBranch = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), companyDistrict = _useState3[0], setCompanyDistrict = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), companyPhone = _useState4[0], setCompanyPhone = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), companyProvince = _useState5[0], setCompanyProvince = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), companyShortName = _useState6[0], setCompanyShortName = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), companySubDistrict = _useState7[0], setCompanySubDistrict = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), companyTaxId = _useState8[0], setCompanyTaxId = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), companyZipCode = _useState9[0], setCompanyZipCode = _useState9[1];
    var _useState10 = _sliced_to_array(useState(""), 2), compQcode = _useState10[0], setCompQcode = _useState10[1];
    var _useState11 = _sliced_to_array(useState(""), 2), compQreferCode = _useState11[0], setCompQreferCode = _useState11[1];
    var _useState12 = _sliced_to_array(useState(""), 2), compQctCode = _useState12[0], setCompQctCode = _useState12[1];
    var _useState13 = _sliced_to_array(useState(0), 2), sumPrice = _useState13[0], setSumPrice = _useState13[1];
    var _useState14 = _sliced_to_array(useState(0), 2), discount = _useState14[0], setDiscount = _useState14[1];
    var _useState15 = _sliced_to_array(useState(1), 2), disType = _useState15[0], setDisType = _useState15[1];
    var _useState16 = _sliced_to_array(useState(0), 2), disTotal = _useState16[0], setDisTotal = _useState16[1];
    var _useState17 = _sliced_to_array(useState(0), 2), priceToDis = _useState17[0], setPriceToDis = _useState17[1];
    var _useState18 = _sliced_to_array(useState(0), 2), vatType = _useState18[0], setVatType = _useState18[1];
    var _useState19 = _sliced_to_array(useState(0), 2), vatTotal = _useState19[0], setVatTotal = _useState19[1];
    var _useState20 = _sliced_to_array(useState(0), 2), taxType = _useState20[0], setTaxType = _useState20[1];
    var _useState21 = _sliced_to_array(useState(0), 2), taxTotal = _useState21[0], setTaxTotal = _useState21[1];
    var _useState22 = _sliced_to_array(useState(0), 2), sumNet = _useState22[0], setSumNet = _useState22[1];
    useEffect(function() {
        if (ptInfoNew) {
            if (ptInfoNew.companyName && ptInfoNew.companyName != "" && ptInfoNew.companyName != null) {
                setCompanyName(ptInfoNew.companyName.trim());
            }
            if (ptInfoNew.companyAddress && ptInfoNew.companyAddress != "" && ptInfoNew.companyAddress != null) {
                setCompanyAddress(ptInfoNew.companyAddress.trim());
            }
            if (ptInfoNew.companyBranch && ptInfoNew.companyBranch != "" && ptInfoNew.companyBranch != null) {
                setCompanyBranch(ptInfoNew.companyBranch.trim());
            }
            if (ptInfoNew.companyDistrict && ptInfoNew.companyDistrict != "" && ptInfoNew.companyDistrict != null) {
                setCompanyDistrict(ptInfoNew.companyDistrict.trim());
            }
            if (ptInfoNew.companyPhone && ptInfoNew.companyPhone != "" && ptInfoNew.companyPhone != null) {
                setCompanyPhone(ptInfoNew.companyPhone.trim());
            }
            if (ptInfoNew.companyProvince && ptInfoNew.companyProvince != "" && ptInfoNew.companyProvince != null) {
                setCompanyProvince(ptInfoNew.companyProvince.trim());
            }
            if (ptInfoNew.companyShortName && ptInfoNew.companyShortName != "" && ptInfoNew.companyShortName != null) {
                setCompanyShortName(ptInfoNew.companyShortName.trim());
            }
            if (ptInfoNew.companySubDistrict && ptInfoNew.companySubDistrict != "" && ptInfoNew.companySubDistrict != null) {
                setCompanySubDistrict(ptInfoNew.companySubDistrict.trim());
            }
            if (ptInfoNew.companyTaxId && ptInfoNew.companyTaxId != "" && ptInfoNew.companyTaxId != null) {
                setCompanyTaxId(ptInfoNew.companyTaxId.trim());
            }
            if (ptInfoNew.companyZipCode && ptInfoNew.companyZipCode != "" && ptInfoNew.companyZipCode != null) {
                setCompanyZipCode(ptInfoNew.companyZipCode.trim());
            }
            if (ptInfoNew.qReferCode && ptInfoNew.qReferCode != "" && ptInfoNew.qReferCode != null) {
                setCompQreferCode(ptInfoNew.qReferCode.trim());
            }
            if (ptInfoNew.qCode && ptInfoNew.qCode != "" && ptInfoNew.qCode != null) {
                setCompQcode(ptInfoNew.qCode.trim());
            }
            if (ptInfoNew.qReferCtCode && ptInfoNew.qReferCtCode != "" && ptInfoNew.qReferCtCode != null) {
                setCompQctCode(ptInfoNew.qReferCtCode.trim());
            }
        }
        if (dataFrom) {
            setSumPrice(convertStringNumber(dataFrom.qr_quotation_totalprice));
            setDiscount(convertStringNumber(dataFrom.qr_quotation_discount));
            setDisType(convertStringNumber(dataFrom.qr_quotation_discounttype));
            setDisTotal(convertStringNumber(dataFrom.qr_quotation_discountreal));
            setPriceToDis(convertStringNumber(dataFrom.qr_quotation_pricediscount));
            setVatType(convertStringNumber(dataFrom.qr_quotation_vat));
            setVatTotal(convertStringNumber(dataFrom.qr_quotation_totalvat));
            setTaxType(convertStringNumber(dataFrom.qr_quotation_tax));
            setTaxTotal(convertStringNumber(dataFrom.qr_quotation_totaltax));
            setSumNet(convertStringNumber(dataFrom.qr_quotation_totalnet));
        }
    }, [
        ptInfoNew,
        dataFrom
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "text-[12.5px] text-[#2C2C2C] mb-1",
            style: {
                width: "210mm",
                height: "297mm",
                padding: "5px 30px",
                margin: "0",
                background: "white",
                position: "relative"
            },
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-xl-4",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "/images/logopardesco.png",
                                    className: "w-[100px]"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6 text-end",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "mt-3",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "ml-5",
                                        children: [
                                            "(",
                                            typeDocPrint && typeDocPrint == 1 ? "ต้นฉบับ" : "สำเนา",
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 text-danger fw-bold",
                                        children: "ใบเสนอราคา"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-end mt-2",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grow pr-[20px]",
                            style: {
                                borderBottom: "1px solid #909090"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[40px]",
                                            children: "ผู้ขาย :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[250px]",
                                            children: "บริษัท พาร์เดสโก้ กรุ๊ป จำากัด (สำนักงานใหญ่ )"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[40px]",
                                            children: "ที่อยู่ :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[250px]",
                                            children: "241/54 ซอยกาญจนาภิเษก 0015 แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพ 10170"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[130px]",
                                            children: "เลขประจำตัวผู้เสียภาษี :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[150px]",
                                            children: "0105568029236"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[60px]"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[250px]"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grow pr-[20px]",
                            style: {
                                borderBottom: "1px solid #909090"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[40px]",
                                            children: "ติดต่อ :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[100px]",
                                            children: "วริธร สวยงาม"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[20px]",
                                            children: /*#__PURE__*/ _jsx(PhoneIcon, {
                                                fontSize: "12"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[100px]",
                                            children: "094-928-0297"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[20px]",
                                            children: /*#__PURE__*/ _jsx(EmailIcon, {
                                                fontSize: "12"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[100px]",
                                            children: "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[20px]",
                                            children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                                fontSize: "12"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[100px]",
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grow pr-[20px] px-2 pt-2",
                            style: {
                                background: "#F6E1E3",
                                borderRadius: 5
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]",
                                            children: "เลขที่เอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[80px]",
                                            children: compQcode
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]",
                                            children: "วันที่ออกเอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[80px]",
                                            children: moment(dataFrom.qr_quotation_issuedate).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]",
                                            children: "วันที่ครบกำหนด :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[80px]",
                                            children: moment(dataFrom.qr_quotation_expiredate).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex flex-end mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]",
                                            children: "อ้างอิง :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[80px]",
                                            children: compQreferCode ? compQreferCode : compQctCode ? compQctCode : "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-end mt-2",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grow pr-[20px]",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[40px]",
                                            children: "ลูกค้า :"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "grow text-[#000] w-[250px]",
                                            children: [
                                                companyName,
                                                " ",
                                                companyBranch ? "(สาขา".concat(companyBranch, ")") : ""
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[40px]",
                                            children: "ที่อยู่ :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[250px]",
                                            children: /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        children: [
                                                            companyAddress + " " + companySubDistrict,
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: companyDistrict + " " + companyProvince + " " + companyZipCode
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[130px]",
                                            children: "เลขประจำตัวผู้เสียภาษี :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[150px]",
                                            children: companyTaxId ? companyTaxId : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[70px]"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[250px]"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grow pr-[20px]",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[50px]",
                                            children: "ผู้ติดต่อ :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[220px]",
                                            children: dataFrom.qr_quotation_mainfname + " " + dataFrom.qr_quotation_mainlname
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[20px]",
                                            children: /*#__PURE__*/ _jsx(PhoneIcon, {
                                                fontSize: "12"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[220px]",
                                            children: dataFrom.qr_quotation_mainphone
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[20px]",
                                            children: /*#__PURE__*/ _jsx(EmailIcon, {
                                                fontSize: "12"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[220px]",
                                            children: dataFrom.qr_quotation_mainemail
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[20px]",
                                            children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                                fontSize: "12"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[220px]",
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "grow pr-[20px] px-2 pt-2",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-none w-[100px]"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "grow text-[#000]"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "py-1",
                    children: /*#__PURE__*/ _jsxs("table", {
                        className: "w-full table-print",
                        children: [
                            /*#__PURE__*/ _jsx("thead", {
                                style: {
                                    background: "#F6E1E3",
                                    borderRadius: 2,
                                    borderColor: "#F6E1E3"
                                },
                                children: /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("th", {
                                            valign: "middle",
                                            width: "6%",
                                            style: {
                                                width: "6%"
                                            },
                                            className: "border-x border-y  text-center font-normal",
                                            children: "รายการ"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            valign: "middle",
                                            width: "2%",
                                            style: {
                                                width: "2%"
                                            },
                                            className: "border-x border-y  text-center font-normal",
                                            children: "จำนวน"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            valign: "middle",
                                            width: "2%",
                                            style: {
                                                width: "2%"
                                            },
                                            className: "border-x border-y  text-center font-normal",
                                            children: "ราคาต่อหน่วย"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            valign: "middle",
                                            width: "2%",
                                            style: {
                                                width: "2%"
                                            },
                                            className: "border-x border-y  text-center font-normal",
                                            children: "ส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            valign: "middle",
                                            width: "2%",
                                            style: {
                                                width: "2%"
                                            },
                                            className: "border-x border-y  text-center font-normal",
                                            children: "ราคารวม"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("tbody", {
                                children: dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_qr_detail = dataFrom.qr_detail) === null || _dataFrom_qr_detail === void 0 ? void 0 : _dataFrom_qr_detail.map(function(ele, i) {
                                    return /*#__PURE__*/ _jsxs("tr", {
                                        style: {
                                            height: "30px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsxs("td", {
                                                className: "border-x ellipsis",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: "".concat(i + 1, ". ").concat(ele.qr_detail_name)
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: "".concat(ele.qr_detail_remark ? "(" + ele.qr_detail_remark + ")" : "")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis  text-center",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: ele.qr_detail_amount
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis  text-center",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: NumberFormat(ele.qr_detail_price, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis  text-center",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: ele.qr_detail_discounttype <= 1 ? NumberFormat(ele.qr_detail_discount, 2) : ele.qr_detail_discount + "%"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis  text-center",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: NumberFormat(ele.qr_detail_net, 2)
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-end py-2 border-y ".concat(((_dataFrom_qr_detail1 = dataFrom.qr_detail) === null || _dataFrom_qr_detail1 === void 0 ? void 0 : _dataFrom_qr_detail1.length) > 5 && "mt-[100px]" || ((_dataFrom_qr_detail2 = dataFrom.qr_detail) === null || _dataFrom_qr_detail2 === void 0 ? void 0 : _dataFrom_qr_detail2.length) < 5 && "mt-[150px]" || ((_dataFrom_qr_detail3 = dataFrom.qr_detail) === null || _dataFrom_qr_detail3 === void 0 ? void 0 : _dataFrom_qr_detail3.length) > 10 && "mt-[0px]"),
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grow pr-[30px]",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "grow text-[#000] w-[20px] fw-bold",
                                            children: [
                                                /*#__PURE__*/ _jsx(AssignmentIcon, {
                                                    fontSize: "18",
                                                    className: "me-1"
                                                }),
                                                "สรุป"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[170px]",
                                            children: "มูลค่าสินค้าก่อนส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-end fw-bold text-[#000] w-[80px]",
                                            children: formatNumber(sumPrice, 2)
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none text-[#000] pl-[10px]",
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[20px] fw-bold"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex-none w-[170px]",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "ส่วนลด"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "pl-[5px] w-bold",
                                                    children: disType == 1 ? NumberFormat(discount, 2) : discount
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "pl-[1px]",
                                                    children: disType <= 1 ? "บาท" : "%"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-end fw-bold text-[#000] w-[80px]",
                                            children: formatNumber(disTotal, 2)
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none text-[#000] pl-[10px]",
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[20px] fw-bold"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[170px]",
                                            children: "มูลค่าสินค้าหลังหักส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-end fw-bold text-[#000] w-[80px]",
                                            children: formatNumber(priceToDis, 2)
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none text-[#000] pl-[10px]",
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[20px] fw-bold"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex-none w-[170px]",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "ภาษีมูลค่าเพิ่ม"
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    className: "pl-[5px] w-bold",
                                                    children: [
                                                        vatType,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-end fw-bold text-[#000] w-[80px]",
                                            children: formatNumber(vatTotal, 2)
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none text-[#000] pl-[10px]",
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[20px] fw-bold"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[170px]",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-end fw-bold text-[#000] w-[80px]",
                                            children: formatNumber(priceToDis + vatTotal, 2)
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none text-[#000] pl-[10px]",
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[20px] fw-bold"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex-none w-[170px]",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "หัก ณ ที่จ่าย"
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    className: "pl-[5px] w-bold",
                                                    children: [
                                                        taxType,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-end fw-bold text-[#000] w-[80px]",
                                            children: formatNumber(taxTotal, 2)
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none text-[#000] pl-[10px]",
                                            children: "บาท"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "grow w-[180px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "px-3 pt-3 pb-1 mt-3 mb-2",
                                style: {
                                    background: "#F6E1E3",
                                    borderRadius: 5
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none fs-14 w-[90px] fw-bold",
                                                children: "มูลค่าสุทธิรวม"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#B00412] fs-16 w-[80px]",
                                                children: formatNumber(sumNet, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px] pt-1",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex mb-2",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-center text-[#000] w-[100px]",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "text-center text-[12.5px] text-[#000] font-semibold",
                                                children: [
                                                    "( ",
                                                    ThaiBahtText(sumNet, 2),
                                                    " )"
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex items-end py-2 border-b",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "grow w-[100px]",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex mb-2",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex-none text-[#000] w-[80px] fw-bold",
                                    children: [
                                        /*#__PURE__*/ _jsx(PaymentsIcon, {
                                            fontSize: "18",
                                            className: "me-1"
                                        }),
                                        " ชำระเงิน"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "growe pr-[10px]",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/images/bankkbank.png",
                                        className: "mt-[10px] w-[30px]"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex-none w-[220px] text-[#000]",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "ธ.กสิกรไทย ( ถนนแจ้งวัฒนะ )"
                                        }),
                                        /*#__PURE__*/ _jsxs("p", {
                                            children: [
                                                "กระแสรายวัน",
                                                " ",
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "text-danger fw-500",
                                                    children: "203-1-87899-6"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "บจก.พาร์เดสโก้ กรุ๊ป"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex items-end py-2",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "grow w-[100px]",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex mb-2",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex-none text-[#000] w-[80px] fw-bold",
                                    children: [
                                        /*#__PURE__*/ _jsx(SpeakerNotesIcon, {
                                            fontSize: "18",
                                            className: "me-1"
                                        }),
                                        " หมายเหตุ"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "growe text-[#000] w-[220px] pr-[10px]",
                                    children: dataFrom.qr_quotation_ramark ? dataFrom.qr_quotation_ramark : ""
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "py-2 text-[11.5px] my-3",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "grid grid-cols-3 gap-3",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex items-start justify-start flex-col",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2",
                                    children: "ในนาม บริษัท พาร์เดสโก้ กรุ๊ป จำกัด"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex items-center justify-center  flex-col",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex items-end justify-end flex-col",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mb-2",
                                    children: [
                                        "ในนาม ",
                                        companyName
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "py-2 text-[11.5px] my-3 px-3",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "grid grid-cols-4 gap-5",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-center flex-col",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2",
                                        style: {
                                            color: "#d8d8d8"
                                        },
                                        children: "__________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "",
                                        children: "ผู้แจ้งหนี้"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-center flex-col",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2",
                                        style: {
                                            color: "#d8d8d8"
                                        },
                                        children: "__________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "",
                                        children: "ตราประทับผู้แจ้งหนี้ (ถ้ามี)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-center flex-col",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2",
                                        style: {
                                            color: "#d8d8d8"
                                        },
                                        children: "__________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "",
                                        children: "ผู้รับเอกสาร"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-center flex-col",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2",
                                        style: {
                                            color: "#d8d8d8"
                                        },
                                        children: "__________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "",
                                        children: "ตราประทับ "
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row my-3",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-12 text-end text-[11.5px]",
                        children: "วันที่ _____/_____/_____ "
                    })
                })
            ]
        })
    });
});
// Styles
var styles = StyleSheet.create(stylesPdfData);
function ContractDocument(_param) {
    var dataFrom = _param.dataFrom, ptInfoNew = _param.ptInfoNew, props = _object_without_properties(_param, [
        "dataFrom",
        "ptInfoNew"
    ]);
    var _dataFrom_qr_detail;
    var rest = _extends({}, _object_destructuring_empty(props));
    var typeDocPrint = props.typeDocPrint ? props.typeDocPrint : 1;
    var cursor = new CursorManager(20, 20);
    return /*#__PURE__*/ _jsx(Document, {
        children: /*#__PURE__*/ _jsxs(Page, {
            size: "A4",
            style: styles.page,
            children: [
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.header,
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            src: "/images/logopardesco.png",
                            style: styles.logo
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                flex: 1,
                                alignItems: "flex-end"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                        marginBottom: 1
                                    }),
                                    children: typeDocPrint && typeDocPrint == 1 ? "( ต้นฉบับ )" : "( สำเนา )"
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread({}, styles.boxInfoDocument),
                                    children: "ใบเสนอราคา"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread_props(_object_spread({}, styles.tableRow), {
                        marginTop: 2,
                        marginBottom: 5
                    }),
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol45P), {
                                borderBottom: "1px solid #909090",
                                paddingTop: 5,
                                paddingBottom: 5
                            }),
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "12%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "ผู้ขาย",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "88%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14B,
                                                children: [
                                                    "บริษัท",
                                                    "\xa0",
                                                    "พาร์เดสโก้",
                                                    "\xa0",
                                                    "กรุ๊ป",
                                                    "\xa0",
                                                    "จำากัด",
                                                    "\xa0",
                                                    "(สำนักงานใหญ่)"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "12%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "ที่อยู่",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(View, {
                                            style: {
                                                width: "88%",
                                                paddingLeft: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                        width: "100%",
                                                        marginBottom: 5
                                                    }),
                                                    children: [
                                                        "241/54",
                                                        "\xa0",
                                                        "ซอยกาญจนาภิเษก",
                                                        "\xa0",
                                                        "0015"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                        width: "100%"
                                                    }),
                                                    children: [
                                                        "แขวงศาลาธรรมสพน์",
                                                        "\xa0",
                                                        "เขตทวีวัฒนา",
                                                        "\xa0",
                                                        "กรุงเทพ",
                                                        "\xa0",
                                                        "10170"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "38%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "เลขประจำตัวผู้เสียภาษี",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "62%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    width: "100%"
                                                }),
                                                children: "0105568029236"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol25P), {
                                borderBottom: "1px solid #909090",
                                paddingTop: 5,
                                paddingBottom: 5
                            }),
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "20%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "ติดต่อ",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "80%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: [
                                                    "วริธร",
                                                    "\xa0",
                                                    "สวยงาม"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "20%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/icons_phone24.png",
                                                style: _object_spread({}, styles.imageDetailIcon)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "80%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: "094-928-0297"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "20%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/icons_email50.png",
                                                style: _object_spread({}, styles.imageDetailIcon)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "80%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: "-"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "20%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/icons_website24.png",
                                                style: _object_spread({}, styles.imageDetailIcon)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "80%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: "-"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol30P), {
                                backgroundColor: "#F6E1E3",
                                borderRadius: 5,
                                padding: "5px 10px"
                            }),
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "เลขที่เอกสาร",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: ptInfoNew && ptInfoNew.qCode && ptInfoNew.qCode != "" && ptInfoNew.qCode != null ? ptInfoNew.qCode.trim() : ""
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "วันที่ออกเอกสาร",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: dataFrom && dataFrom.qr_quotation_issuedate && dataFrom.qr_quotation_issuedate != "" && dataFrom.qr_quotation_issuedate != null ? moment(dataFrom.qr_quotation_issuedate).format("DD/MM/YYYY") : ""
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "วันที่ครบกำหนด",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: dataFrom && dataFrom.qr_quotation_expiredate && dataFrom.qr_quotation_expiredate != "" && dataFrom.qr_quotation_expiredate != null ? moment(dataFrom.qr_quotation_expiredate).format("DD/MM/YYYY") : ""
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "อ้างอิง",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: ptInfoNew && ptInfoNew.qReferCode && ptInfoNew.qReferCode != "" && ptInfoNew.qReferCode != null ? ptInfoNew.qReferCode.trim() : ptInfoNew && ptInfoNew.qReferCtCode && ptInfoNew.qReferCtCode != "" && ptInfoNew.qReferCtCode != null ? ptInfoNew.qReferCtCode.trim() : ""
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread_props(_object_spread({}, styles.tableRow), {
                        marginBottom: 5
                    }),
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: _object_spread({}, styles.tableCol45P),
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "12%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "ลูกค้า",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "88%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: styles.textDetail14B,
                                                children: ptInfoNew && ptInfoNew.companyName && ptInfoNew.companyName != "" && ptInfoNew.companyName != null ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        ptInfoNew.companyName.trim() + "\xa0",
                                                        ptInfoNew.companyBranch && ptInfoNew.companyBranch != "" && ptInfoNew.companyBranch != null && ptInfoNew.companyBranch != "สำนักงานใหญ่" ? "(สาขา" + "\xa0" + ptInfoNew.companyBranch.trim() + ")" : "(สำนักงานใหญ่)"
                                                    ]
                                                }) : ""
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "12%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "ที่อยู่",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(View, {
                                            style: {
                                                width: "88%",
                                                paddingLeft: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                        width: "100%",
                                                        marginBottom: 5
                                                    }),
                                                    children: ptInfoNew && ptInfoNew.companyAddress && ptInfoNew.companyAddress != "" && ptInfoNew.companyAddress != null ? filterTextAndNum(ptInfoNew.companyAddress.trim(), 3) : ""
                                                }),
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                        width: "100%"
                                                    }),
                                                    children: [
                                                        ptInfoNew && ptInfoNew.companySubDistrict && ptInfoNew.companySubDistrict != "" && ptInfoNew.companySubDistrict != null ? ptInfoNew.companySubDistrict.trim() : "",
                                                        ptInfoNew && ptInfoNew.companyDistrict && ptInfoNew.companyDistrict != "" && ptInfoNew.companyDistrict != null ? "\xa0" + ptInfoNew.companyDistrict.trim() : "",
                                                        ptInfoNew && ptInfoNew.companyProvince && ptInfoNew.companyProvince != "" && ptInfoNew.companyProvince != null ? "\xa0" + ptInfoNew.companyProvince.trim() : "",
                                                        ptInfoNew && ptInfoNew.companyZipCode && ptInfoNew.companyZipCode != "" && ptInfoNew.companyZipCode != null ? "\xa0" + ptInfoNew.companyZipCode.trim() : ""
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "38%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "เลขประจำตัวผู้เสียภาษี",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "62%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    width: "100%"
                                                }),
                                                children: ptInfoNew && ptInfoNew.companyTaxId && ptInfoNew.companyTaxId != "" && ptInfoNew.companyTaxId != null ? ptInfoNew.companyTaxId.trim() : "-"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: "55%"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "12%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: styles.textDetail14P,
                                                children: [
                                                    "ผู้ติดต่อ",
                                                    "\xa0",
                                                    ":"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "88%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: [
                                                    dataFrom && dataFrom.qr_quotation_mainfname && dataFrom.qr_quotation_mainfname != "" && dataFrom.qr_quotation_mainfname != null ? dataFrom.qr_quotation_mainfname.trim() : "",
                                                    dataFrom && dataFrom.qr_quotation_mainlname && dataFrom.qr_quotation_mainlname != "" && dataFrom.qr_quotation_mainlname != null ? "\xa0" + dataFrom.qr_quotation_mainlname.trim() : ""
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "10%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/icons_phone24.png",
                                                style: _object_spread({}, styles.imageDetailIcon)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "90%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: dataFrom && dataFrom.qr_quotation_mainphone && dataFrom.qr_quotation_mainphone != "" && dataFrom.qr_quotation_mainphone != null ? dataFrom.qr_quotation_mainphone.trim() : ""
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "10%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/icons_email50.png",
                                                style: _object_spread({}, styles.imageDetailIcon)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "90%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: dataFrom && dataFrom.qr_quotation_mainemail && dataFrom.qr_quotation_mainemail != "" && dataFrom.qr_quotation_mainemail != null ? dataFrom.qr_quotation_mainemail.trim() : ""
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "10%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/icons_website24.png",
                                                style: _object_spread({}, styles.imageDetailIcon)
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "90%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: "-"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread_props(_object_spread({}, styles.table), {
                        marginBottom: 5
                    }),
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: styles.tableRow,
                            children: [
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, styles.tableCol40P),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "รายการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "จำนวน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "ราคาต่อหน่วย"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "ส่วนลด"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, styles.tableCol15P),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "ราคารวม"
                                    })
                                })
                            ]
                        }),
                        dataFrom && dataFrom.qr_detail && dataFrom.qr_detail.length > 0 ? dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_qr_detail = dataFrom.qr_detail) === null || _dataFrom_qr_detail === void 0 ? void 0 : _dataFrom_qr_detail.map(function(ele, i) {
                            return /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: _object_spread_props(_object_spread({}, styles.tableCol40P), {
                                            padding: "2px 5px"
                                        }),
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textWrap: "balance",
                                                    fontWeight: "bold",
                                                    width: "100%"
                                                }),
                                                children: "".concat(i + 1, ". ").concat(ele.qr_detail_name)
                                            }),
                                            ele.qr_detail_remark && ele.qr_detail_remark != "" && ele.qr_detail_remark != null ? /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textWrap: "balance",
                                                    fontWeight: "bold",
                                                    width: "100%"
                                                }),
                                                children: "(" + ele.qr_detail_remark + ")"
                                            }) : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread_props(_object_spread({}, styles.tableCol15P), {
                                            padding: "2px 5px"
                                        }),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                textAlign: "center",
                                                fontWeight: "bold"
                                            }),
                                            children: ele.qr_detail_amount && ele.qr_detail_amount > 0 ? NumberFormat(ele.qr_detail_amount, 0) : 0
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread_props(_object_spread({}, styles.tableCol15P), {
                                            padding: "2px 5px"
                                        }),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                textAlign: "center",
                                                fontWeight: "bold"
                                            }),
                                            children: ele.qr_detail_price && ele.qr_detail_price > 0.01 ? NumberFormat(ele.qr_detail_price, 2) : NumberFormat(0, 2)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread_props(_object_spread({}, styles.tableCol15P), {
                                            padding: "2px 5px"
                                        }),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                textAlign: "center",
                                                fontWeight: "bold"
                                            }),
                                            children: ele.qr_detail_discount && ele.qr_detail_discount > 0 && ele.qr_detail_discounttype <= 1 ? NumberFormat(ele.qr_detail_discount, 2) : ele.qr_detail_discount && ele.qr_detail_discount > 0 && ele.qr_detail_discounttype > 1 ? ele.qr_detail_discount + "%" : NumberFormat(0, 2)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread_props(_object_spread({}, styles.tableCol15P), {
                                            padding: "2px 5px"
                                        }),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                textAlign: "center",
                                                fontWeight: "bold"
                                            }),
                                            children: ele.qr_detail_net && ele.qr_detail_net > 0.01 ? NumberFormat(ele.qr_detail_net, 2) : NumberFormat(0, 2)
                                        })
                                    })
                                ]
                            });
                        }) : /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    width: "100%",
                                    padding: "2px 5px"
                                },
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                        textAlign: "center",
                                        fontWeight: "bold"
                                    }),
                                    children: "ไม่พบข้อมูล"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread_props(_object_spread({}, styles.tableRow), {
                        marginBottom: 5,
                        marginTop: dataFrom && dataFrom.qr_detail && dataFrom.qr_detail.length > 10 ? 0 : dataFrom && dataFrom.qr_detail && dataFrom.qr_detail.length >= 5 ? 100 : 100,
                        borderTop: "1px solid #ddd"
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol10P), {
                                paddingTop: 5,
                                paddingBottom: 5
                            }),
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: styles.textDetail14B,
                                children: "สรุป"
                            })
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol50P), {
                                padding: 5
                            }),
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                    textAlign: "left"
                                                }),
                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    textAlign: "right"
                                                }),
                                                children: [
                                                    dataFrom && dataFrom.qr_quotation_totalprice && dataFrom.qr_quotation_totalprice > 0.01 ? NumberFormat(dataFrom.qr_quotation_totalprice, 2) : NumberFormat(0, 2),
                                                    "\xa0\xa0",
                                                    "บาท"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                    textAlign: "left"
                                                }),
                                                children: [
                                                    "ส่วนลด",
                                                    "\xa0",
                                                    dataFrom && dataFrom.qr_quotation_discount && dataFrom.qr_quotation_discount > 0.01 ? /*#__PURE__*/ _jsx(_Fragment, {
                                                        children: dataFrom && dataFrom.qr_quotation_discounttype && dataFrom.qr_quotation_discounttype == 1 ? NumberFormat(dataFrom.qr_quotation_discount, 2) : dataFrom.qr_quotation_discount
                                                    }) : 0,
                                                    "\xa0",
                                                    dataFrom && dataFrom.qr_quotation_discounttype && dataFrom.qr_quotation_discounttype > 1 ? "%" : "บาท"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    textAlign: "right"
                                                }),
                                                children: [
                                                    dataFrom && dataFrom.qr_quotation_discountreal && dataFrom.qr_quotation_discountreal > 0.01 ? NumberFormat(dataFrom.qr_quotation_discountreal, 2) : NumberFormat(0, 2),
                                                    "\xa0\xa0",
                                                    "บาท"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                    textAlign: "left"
                                                }),
                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    textAlign: "right"
                                                }),
                                                children: [
                                                    dataFrom && dataFrom.qr_quotation_pricediscount && dataFrom.qr_quotation_pricediscount > 0.01 ? NumberFormat(dataFrom.qr_quotation_pricediscount, 2) : NumberFormat(0, 2),
                                                    "\xa0\xa0",
                                                    "บาท"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                    textAlign: "left"
                                                }),
                                                children: [
                                                    "ภาษีมูลค่าเพิ่ม",
                                                    "\xa0",
                                                    dataFrom && dataFrom.qr_quotation_vat && dataFrom.qr_quotation_vat > 0.01 ? NumberFormat(dataFrom.qr_quotation_vat, 0) : NumberFormat(0, 0),
                                                    "\xa0",
                                                    "%"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    textAlign: "right"
                                                }),
                                                children: [
                                                    dataFrom && dataFrom.qr_quotation_totalvat && dataFrom.qr_quotation_totalvat > 0.01 ? NumberFormat(dataFrom.qr_quotation_totalvat, 2) : NumberFormat(0, 2),
                                                    "\xa0\xa0",
                                                    "บาท"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                    textAlign: "left"
                                                }),
                                                children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    textAlign: "right"
                                                }),
                                                children: [
                                                    dataFrom && dataFrom.qr_quotation_pricediscount && dataFrom.qr_quotation_pricediscount > 0.01 && dataFrom.qr_quotation_totalvat && dataFrom.qr_quotation_totalvat > 0.01 ? NumberFormat(dataFrom.qr_quotation_pricediscount + dataFrom.qr_quotation_totalvat, 2) : dataFrom && dataFrom.qr_quotation_pricediscount && dataFrom.qr_quotation_pricediscount > 0.01 && (!dataFrom.qr_quotation_totalvat || dataFrom.qr_quotation_totalvat < 0.01) ? NumberFormat(dataFrom.qr_quotation_pricediscount, 2) : dataFrom && dataFrom.qr_quotation_totalvat && dataFrom.qr_quotation_totalvat > 0.01 && (!dataFrom.qr_quotation_pricediscount || dataFrom.qr_quotation_pricediscount < 0.01) ? NumberFormat(dataFrom.qr_quotation_totalvat, 2) : NumberFormat(0, 2),
                                                    "\xa0\xa0",
                                                    "บาท"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        width: "100%",
                                        marginBottom: 5,
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                    textAlign: "left"
                                                }),
                                                children: [
                                                    "หัก",
                                                    "\xa0",
                                                    "ณ",
                                                    "\xa0",
                                                    "ที่จ่าย",
                                                    "\xa0",
                                                    dataFrom && dataFrom.qr_quotation_tax && dataFrom.qr_quotation_tax > 0.01 ? NumberFormat(dataFrom.qr_quotation_tax, 0) : 0,
                                                    "\xa0",
                                                    "%"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "50%",
                                                paddingLeft: 1
                                            },
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    textAlign: "right"
                                                }),
                                                children: [
                                                    dataFrom && dataFrom.qr_quotation_totaltax && dataFrom.qr_quotation_totaltax > 0.01 ? NumberFormat(dataFrom.qr_quotation_totaltax, 2) : NumberFormat(0, 2),
                                                    "\xa0\xa0",
                                                    "บาท"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol40P), {
                                paddingTop: 5,
                                paddingBottom: 5,
                                paddingLeft: 10,
                                flexDirection: "column",
                                justifyContent: "flex-end"
                            }),
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    width: "100%",
                                    backgroundColor: "#F6E1E3",
                                    borderRadius: 5,
                                    padding: "5px 10px"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: {
                                            width: "100%",
                                            marginBottom: 5,
                                            flexDirection: "row"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(View, {
                                                style: {
                                                    width: "40%"
                                                },
                                                children: /*#__PURE__*/ _jsx(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail16B), {
                                                        textAlign: "left"
                                                    }),
                                                    children: "มูลค่าสุทธิรวม"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(View, {
                                                style: {
                                                    width: "60%",
                                                    paddingLeft: 1
                                                },
                                                children: /*#__PURE__*/ _jsxs(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail16B), {
                                                        textAlign: "right",
                                                        color: "#B00412"
                                                    }),
                                                    children: [
                                                        dataFrom && dataFrom.qr_quotation_totalnet && dataFrom.qr_quotation_totalnet > 0.01 ? NumberFormat(dataFrom.qr_quotation_totalnet, 2) : NumberFormat(0, 2),
                                                        "\xa0\xa0",
                                                        "บาท"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: {
                                            width: "100%",
                                            marginBottom: 5,
                                            flexDirection: "row"
                                        },
                                        children: /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                width: "100%"
                                            },
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    textAlign: "center"
                                                }),
                                                children: dataFrom && dataFrom.qr_quotation_totalnet && dataFrom.qr_quotation_totalnet > 0.01 ? "(" + "\xa0" + ThaiBahtText(dataFrom.qr_quotation_totalnet, 2) + "\xa0" + ")" : "(" + "\xa0" + ThaiBahtText(0, 2) + "\xa0" + ")"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread_props(_object_spread({}, styles.tableRow), {
                        marginBottom: 5,
                        borderTop: "1px solid #ddd"
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol10P), {
                                paddingTop: 5,
                                paddingBottom: 5
                            }),
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: styles.textDetail14B,
                                children: "ชำระเงิน"
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol50P), {
                                padding: 5
                            }),
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    width: "100%",
                                    flexDirection: "row"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: {
                                            width: 40,
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            src: "/images/bankkbank.png",
                                            style: {
                                                width: 40,
                                                height: 40
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: {
                                            minWidth: 220,
                                            paddingLeft: 5,
                                            justifyContent: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    width: "100%"
                                                }),
                                                children: [
                                                    "ธ.กสิกรไทย",
                                                    "\xa0",
                                                    "(",
                                                    "\xa0",
                                                    "ถนนแจ้งวัฒนะ",
                                                    "\xa0",
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    width: "100%"
                                                }),
                                                children: [
                                                    "กระแสรายวัน",
                                                    "\xa0",
                                                    /*#__PURE__*/ _jsx(Text, {
                                                        style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                            color: "#dc3545"
                                                        }),
                                                        children: "203-1-87899-6"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                    width: "100%"
                                                }),
                                                children: [
                                                    "บจก.พาร์เดสโก้",
                                                    "\xa0",
                                                    "กรุ๊ป"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread_props(_object_spread({}, styles.tableRow), {
                        marginBottom: 5,
                        borderTop: "1px solid #ddd"
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol10P), {
                                paddingTop: 5,
                                paddingBottom: 5
                            }),
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: styles.textDetail14B,
                                children: "หมายเหตุ"
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol90P), {
                                paddingTop: 5,
                                paddingBottom: 5
                            }),
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: styles.textDetail14P,
                                children: dataFrom && dataFrom.qr_quotation_ramark && dataFrom.qr_quotation_ramark != "" && dataFrom.qr_quotation_ramark != null ? filterTextAndNum(dataFrom.qr_quotation_ramark.trim(), 3) : ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread_props(_object_spread({}, styles.tableRow), {
                        marginBottom: 5
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread({}, styles.tableCol50P),
                            children: /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                    textAlign: "left"
                                }),
                                children: [
                                    "ในนาม",
                                    "\xa0",
                                    "บริษัท",
                                    "\xa0",
                                    "พาร์เดสโก้",
                                    "\xa0",
                                    "กรุ๊ป",
                                    "\xa0",
                                    "จำกัด"
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread({}, styles.tableCol50P),
                            children: /*#__PURE__*/ _jsxs(Text, {
                                style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                    textAlign: "right"
                                }),
                                children: [
                                    "ในนาม",
                                    "\xa0",
                                    ptInfoNew && ptInfoNew.companyName && ptInfoNew.companyName != "" && ptInfoNew.companyName != null ? filterTextAndNum(ptInfoNew.companyName.trim(), 3) : "....................................................."
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread_props(_object_spread({}, styles.tableRow), {
                        marginBottom: 5
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol25P), {
                                paddingTop: 35
                            }),
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.signatureBorder),
                                children: "ผู้แจ้งหนี้"
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol25P), {
                                paddingTop: 35
                            }),
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.signatureBorder),
                                children: "ตราประทับผู้แจ้งหนี้ (ถ้ามี)"
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol25P), {
                                paddingTop: 35
                            }),
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.signatureBorder),
                                children: "ผู้รับเอกสาร"
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol25P), {
                                paddingTop: 35
                            }),
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread({}, styles.signatureBorder),
                                children: "ตราประทับ"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: _object_spread_props(_object_spread({}, styles.tableRow), {
                        marginTop: 7
                    }),
                    children: /*#__PURE__*/ _jsx(View, {
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                textAlign: "right"
                            }),
                            children: "วันที่ _____/_____/_____"
                        })
                    })
                })
            ]
        })
    });
}
